import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, QueryList, signal, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation, WritableSignal } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { DocumentPreviewTypes } from 'countable@helpers';
import { FirmModel, SPIN_STYLES, SpinInputModel } from 'countable@model';
import { FirmService, FsExportService } from 'countable@services';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, finalize } from 'rxjs/operators';
import { ResizeModel } from 'src/app/model/eng/resize.model';
import { Column, Row, TableSection, TextSection } from 'src/app/model/notes/notes-to-fs.model';
import { TimeTrackerService } from 'src/app/services/time-tracker.service';
import { HeaderNameModel } from '../../../../model/workbook/header-name.model';
import { ApiService } from '../../../../services/api.service';
import { idleTime, modules } from '../../../../services/app-config';
import { EncodingService } from '../../../../services/encoding.service';
import { EngApiService } from '../../../../services/eng-api.service';
import { NotesToFsService } from '../../../../services/notes-to-fs.service';
import { WorkbookService } from '../../../../services/workbook.service';
import { SharedService } from '../../../shared/shared.service';
import { CustomEditorComponent } from '../../custom-editor/custom-editor.component';
import { FsTableComponent } from '../../fs-table/fs-table.component';

const objectsEqual = (o1, o2) =>
	Object.keys(o1).length === Object.keys(o2).length
	&& Object.keys(o1).every(p => {
		if (Array.isArray(o1[p])) {
			return o1[p].toString() === o2[p].toString();
		} else {
			return o1[p] === o2[p];
		}
	});

@Component({
  selector: 'fs-notes',
  templateUrl: 'fs-notes.component.html',
  styleUrls: ['fs-notes.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe],
  standalone: false
})

export class FsNotesComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('notesFSImportSelectionDialog') notesFSImportSelectionDialogTemp: TemplateRef<any>;
	@ViewChild('deleteDialog') deleteDialog: TemplateRef<any>;
	@ViewChild('createCategoryDialog') createCategoryDialog: TemplateRef<any>;
	@ViewChild('CreateNotesToFsDialog') CreateNotesToFsDialog: TemplateRef<any>;
	@ViewChildren(FsTableComponent) fsTableComponent!: QueryList<FsTableComponent>;
	@ViewChildren(CustomEditorComponent) customEditorComponent!: QueryList<CustomEditorComponent>;

  @ViewChild('drawer') drawer: MatDrawer;

	importOptions = [{ id: 1, value: "From Master library" }, { id: 0, value: "From Firm Templates" }];
	notesSRC: number = 0;
	rename = false;
	isFSNotesExpanded = false;
	userLoginId: any;
	engagementID: any;
	notes: any = [];
	middleNotes: any = [];
	allNotesCheked = false;
	clientName: any;
	engagementData: any;
	workBookSubModuleId: any;
	engagementYearEnd: any;
	headerNotesColumn1: string = '';
	headerNotesColumn2: string = '';
	headerNotesColumn3: string = '';
	isSecondColumnClicked: boolean = false;
	isThirdColumnClicked: boolean = false;
	userData: any;
	shortCutMenuDetails: any;
	isOldSecondColumn: string = '';
	isOldThirdColumn: string = '';
	subject: any;
	firmUserAcctId: any;
	selectedEngagement: any;
	notesCount: number = 0;
	editorData = [];
	selection = false;
	isSelectAll = false;
	isShowEditor = false;
	oldCategoryName: string = '';
	oldSubCategoryName: string = '';
	isCategoryDelete: boolean = false;
	isSubCategoryDelete: boolean = false;
	deleteAll: boolean = false;
	searchText: string = null;
	searchMdText: string = null;
	isNotesExpanded = false;
	oldContent: string;
	isdelete: boolean = false;
	connectedTo = [];
	trackobj: { engagementsId: any; submoduleId: any; submoduleUuid: any; };
	userActivity;
	userInactiveSub: Subscription;
	userInactive: Subject<any> = new Subject();
	totalNotesCount: number;
	isUpdateNotes: boolean;
	isUpdateNotesObj: any = {};
	balanceSheetDetails: any = [];
	acctYear: any;
	notesIndex: number;
	dialogboxText: string = '';
	dialogboxHeader: string = '';
	dialogboxLinkedText: string = '';
	deletableLinkedNotes = [];
	CreateCategoryName: any;
	incomeStatementdetails: any;
	incomesheetdeletableLinkedNotes: any;
	countryId: number;
	stockholderdeletableLinkedNotes: any[];
	stockHolderSubmoduleId: any;
	cashFlowSubModuleId: any;
	trialBalanceData: any = [];
	addNotesExpandAll: boolean = false;
	isFsTableNoteError: boolean = false;
	isFsTableNoteSave: boolean = false;
	autoLeadSheetData: any[] = [];
	lsUpdated = false;
	tbUpdated = false;
	rollForwardJsonUpdated: any = null;
	previousEditNote: number = -1;

	public subscriptions: Subscription = new Subscription();
	public notes$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	public notesEditted: boolean = false;

	private notesToFsSubject: Subject<string> = new Subject();
	private notesMdSubject: Subject<string> = new Subject();
	isPegPactExpired = signal<boolean>(false);
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null, SPIN_STYLES.LINE));
  private spinCount: number = 0;
  private viewNoteId: string = null;

	@HostListener('window:mousemove', ["$event"])
	@HostListener('window:resize', ["$event"])
	@HostListener('window:keydown', ["$event"])
	refreshUserState() {
		clearTimeout(this.userActivity);
		if (localStorage.getItem("timerStatus") == "Idle")
			this.trackerService.startTimer("Active");
		this.setTimeout();
	}
	@HostListener('window:beforeunload', ['$event'])
	beforeunloadHandler(event) {
		localStorage.setItem("isOpenWB", "false");
	}
	@HostListener('window:storage', ['$event'])
	async onStorageChange(ev: StorageEvent) {
		if (ev.key == 'refresh_LS_Data') {
			await this.getNotesLeadSheetData().then(response => {
				this.autoLeadSheetData = JSON.parse(JSON.stringify(response));
			});
			this.sharedService.notesLeadSheetData$.next(this.autoLeadSheetData);
			this.updateNotesWithLeadSheetValues();
			if (this.lsUpdated) {
				this.saveMiddleNotes(this.middleNotes, "updatedTBValues");
			}
		}
	}

  constructor(private apiService: ApiService, private fsService: FsExportService, private noteService: NotesToFsService,
              private sharedService: SharedService, public dialog: MatDialog, private toaster: ToastrService,
              public datePipe: DatePipe, private trackerService: TimeTrackerService,
              private router: ActivatedRoute, private encodingService: EncodingService, private cdr: ChangeDetectorRef,
              private firmService: FirmService, private wbService: WorkbookService, private engApiService: EngApiService) {
		this.setTimeout();
		this.userInactive.subscribe(() => {
			this.trackerService.startTimer("Idle");
		});
		this.subscriptions.add(
			this.firmService.subject.subscribe({
			  next: (firm : FirmModel) => {
          if (firm) {
					this.isPegPactExpired.set(firm.isPegPacValid);
				}
			  },
			  error: (err) => {
				console.log(err);
			  }
			})
		);

  }

	ngOnInit() {
		this.engagementID = JSON.parse((localStorage.getItem('engagementID')));
		this.selectedEngagement = JSON.parse((localStorage.getItem('selectedEngagementObj')));
		this.userLoginId = this.sharedService.getUserData("field", "useracctid");
		this.firmUserAcctId = this.sharedService.getUserData("field", "firmUserAcctId");
		this.userData = JSON.parse(localStorage.getItem('userDetails'));
		this.workBookSubModuleId = localStorage.getItem('workBookSubmoduleId');
		this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
		this.engagementData = JSON.parse(localStorage.getItem("selectedEngagementObj"));
		let selectedObj = JSON.parse(localStorage.getItem("selectedEngagementObjCopy"));
		this.engagementYearEnd = localStorage.getItem("endYear");
		this.clientName = selectedObj.clientName
		this.countryId = +this.sharedService.getUserData('field', 'origin_country_id');
		this.getNotesTrialBalanceData();
		// this.getTBLSHeaderNotes();
		this.getBalanceSheetDetails('');
		this.getIncomeStatementDetails('');
		this.getwbleftside()
		//this.getMiddleNotes();
		this.trackobj = {
			"engagementsId": this.engagementID,
			"submoduleId": this.workBookSubModuleId,
			"submoduleUuid": localStorage.getItem("UUID"),
		}
		localStorage.setItem("timeTrackerObj", JSON.stringify(this.trackobj));
		this.trackerService.startTimer("Active");

		this.notesToFsSubject.pipe(
			// if character length greater then 2
			filter(res => res.length > 2 || res.length < 3 || res.length != 0)
			// Time in milliseconds between key events
			, debounceTime(1000)
			// If previous query is diffent from current
			, distinctUntilChanged()
		).subscribe((text: string) => {
			this.getSearchedDetails();
		});

		this.notesMdSubject.pipe(
			filter(res => res.length > 2 || res.length < 3 || res.length != 0),
			debounceTime(1000),
			distinctUntilChanged()
		).subscribe((text: string) => {
			this.getMiddleSearchedDetails();
		});

			this.router.queryParams.subscribe(param => {
        this.viewNoteId = param?.NoteId ? param?.NoteId : null;
			})


    this.subscriptions.add(
			this.notes$.pipe().subscribe({
				next: notesData => {
					if (notesData) {
						// console.log(notesData);

						// let cashFlowJSON = JSON.parse(notesData);
						// cashFlowJSON = cashFlowJSON.cashFlow;

						// Middle data
						// let result = JSON.parse(cashFlowJSON["cashFlowData"]);
						// this.cashFlowTableData = result.sections;
						// this.cfDataSource = JSON.parse(JSON.stringify(result.sections));
						// this.cashFlowTableData.splice(this.cashFlowTableData.length - 1, 0, { id: 'crossCheck', totalName: '', currYearTotal: result.crossCheckValueCY, crossCheckValueCY: result.crossCheckValueCY, prevYearTotal: result.crossCheckValuePY, crossCheckValuePY: result.crossCheckValuePY, isSection: false });

						// localStorage.removeItem('refreshCashFlow_CF');
						// localStorage.setItem('refreshCashFlow_CF', "refresh");
						// this.isRefreshSubject.next({ data: this.cashFlowTableData, crossCheck: result });
						// this.togglePannels('E');

						// Preview data
						document.getElementById("notes-preview").innerHTML = notesData;
					}

				}
			})
		);
	}

	ngAfterViewInit() {
		this.cdr.detectChanges();
	}
	canDeactivate(): boolean {
		// return (this.saveEnabled() || this.justEditChanged()) ? false : true;
		return (this.notesEditted === true || this.sharedService.isFirmTemplatesNotesEditoropened === true) ? false : true;
	}
	setTimeout() {
		this.userActivity = setTimeout(() => this.userInactive.next(undefined), idleTime);
	}

	joinMiddleNotesIntoSingleArray() {
		var tarray = JSON.parse(JSON.stringify(this.middleNotes))
		tarray.filter(x => !x.id).forEach(ele => {
			if (ele.notes) {
				ele.notes.forEach(e => {
					tarray.push(e)
				})
			}
		})
		tarray = tarray.filter(x => x.id)
		return tarray
	}

	detectChangeInNotesRelatedToIncomeStatement(changetype, obj?) {
		this.incomesheetdeletableLinkedNotes = [];
		var incomesheetpayload = [];
		var tempary = [];
		if (this.incomeStatementdetails?.length) {
			for (let i = 0; i < this.incomeStatementdetails.length; i++) {
				if (this.incomeStatementdetails[i].children && this.incomeStatementdetails[i].children.length) {
					for (let j = 0; j < this.incomeStatementdetails[i].children.length; j++) {
						if (this.incomeStatementdetails[i].children[j].children && this.incomeStatementdetails[i].children[j].children.length) {
							for (let k = 0; k < this.incomeStatementdetails[i].children[j].children.length; k++) {
								if (this.incomeStatementdetails[i].children[j].children[k].notes) {
									if (changetype == 'rename' && obj) {
										var indx = this.incomeStatementdetails[i].children[j].children[k].notes.findIndex(x => x.noteid == obj.id);
										if (indx > -1) {
											var payload = {
												"save": [{
													"engagementsId": this.engagementID,
													"finSubgroupChildId": this.incomeStatementdetails[i].children[j].children[k].notes[indx].finsubgroupchildid,
													"finSubgroupId": "",
													"submoduleId": this.incomeStatementdetails[i].children[j].children[k].notes[indx].submoduleid,
													"noteName": obj.name,
													"noteId": obj.id.toString(),
													"engNoteId": obj.engNoteId.toString(),
													"isChanged": 1,
													"isDelete": 0,
													"loginId": this.userLoginId,
													"acctYear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
													"workbookNotesId": this.incomeStatementdetails[i].children[j].children[k].notes[indx].workbooknotesid
												}]
											}
											this.apiService.saveNotesBalanceSheet(payload).subscribe(resp => {
												if (resp && resp == 'Success') {
													this.getIncomeStatementDetails("");
													return
												}
											})
										}
									}
									else if (changetype == "draganddrop" || changetype == 'delete') {
										tempary = this.joinMiddleNotesIntoSingleArray();

										for (let l = 0; l < this.incomeStatementdetails[i].children[j].children[k].notes.length; l++) {
											if (changetype == 'delete') {
												if (this.isCategoryDelete) {
													var categoryindx = this.middleNotes.findIndex(x => x.isDelete == true);
													if (categoryindx > -1) {
														if (this.middleNotes[categoryindx].categoryId && this.middleNotes[categoryindx]?.notes) {
															if (this.middleNotes[categoryindx].notes.find(y => y.id == this.incomeStatementdetails[i].children[j].children[k].notes[l].noteid)) {
																this.incomesheetdeletableLinkedNotes.push(this.incomeStatementdetails[i].children[j].children[k].notes[l])
															}
														}
														else if (!this.middleNotes[categoryindx].categoryId && this.middleNotes[categoryindx].id) {
															if (this.middleNotes.find(y => y.id == this.incomeStatementdetails[i].children[j].children[k].notes[l].noteid && y.isDelete == true)) {
																this.incomesheetdeletableLinkedNotes.push(this.incomeStatementdetails[i].children[j].children[k].notes[l])
															}
														}
													}
												}
												else if (this.isSubCategoryDelete) {
													for (let index = 0; index < this.middleNotes.length; index++) {
														if (this.middleNotes[index].notes) {
															if (this.middleNotes[index].notes.find(y => y.id == this.incomeStatementdetails[i].children[j].children[k].notes[l].noteid && y.isDelete == true)) {
																this.incomesheetdeletableLinkedNotes.push(this.incomeStatementdetails[i].children[j].children[k].notes[l])
															}
														}
													}
												}
												else if (this.deleteAll) {
													if (tempary.find(x => x.is_checked == true && x.id == this.incomeStatementdetails[i].children[j].children[k].notes[l].noteid)) {
														this.incomesheetdeletableLinkedNotes.push(this.incomeStatementdetails[i].children[j].children[k].notes[l])
													}
												}
											}
											else if (changetype == "draganddrop") {
												var tempary_obj = tempary.find(y => y.id == this.incomeStatementdetails[i].children[j].children[k].notes[l].noteid)
												if (tempary_obj) {
													let pobj = {
														"engagementsId": this.engagementID,
														"finSubgroupChildId": this.incomeStatementdetails[i].children[j].children[k].notes[l].finsubgroupchildid,
														"finSubgroupId": "",
														"submoduleId": this.incomeStatementdetails[i].children[j].children[k].notes[l].submoduleid,
														"noteName": tempary_obj.name,
														"noteId": tempary_obj.id.toString(),
														"engNoteId": tempary_obj.engNoteId.toString(),
														"isChanged": 1,
														"isDelete": 0,
														"loginId": this.userLoginId,
														"acctYear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
														"workbookNotesId": this.incomeStatementdetails[i].children[j].children[k].notes[l].workbooknotesid
													}
													incomesheetpayload.push(pobj)
												}
											}

										}


									}
								}

							}
						}

					}
				}

			}
		}
		if (changetype == "draganddrop" && incomesheetpayload) {
			if (incomesheetpayload.length > 0)
				this.apiService.saveNotesBalanceSheet({ "save": incomesheetpayload }).subscribe(resp => {
					if (resp && resp == 'Success') {
						this.getIncomeStatementDetails("");
					}
				})
		}
	}
	detectChangeInNotesRelatedToBalancesheet(changetype, obj?) {
		this.deletableLinkedNotes = [];
		var balancesheetpayload = [];
		var tempary = [];
		for (let i = 0; i < this.balanceSheetDetails.length; i++) {
			if (this.balanceSheetDetails[i].children && this.balanceSheetDetails[i].children.length) {
				for (let j = 0; j < this.balanceSheetDetails[i].children.length; j++) {
					if (this.balanceSheetDetails[i].children[j].children && this.balanceSheetDetails[i].children[j].children.length) {
						for (let k = 0; k < this.balanceSheetDetails[i].children[j].children.length; k++) {
							if (this.balanceSheetDetails[i].children[j].children[k].notes) {
								if (changetype == 'rename' && obj) {
									var indx = this.balanceSheetDetails[i].children[j].children[k].notes.findIndex(x => x.noteid == obj.id);
									if (indx > -1) {
										var payload = {
											"save": [{
												"engagementsId": this.engagementID,
												"finSubgroupChildId": this.balanceSheetDetails[i].children[j].children[k].notes[indx].finsubgroupchildid,
												"finSubgroupId": "",
												"submoduleId": this.balanceSheetDetails[i].children[j].children[k].notes[indx].submoduleid,
												"noteName": obj.name,
												"noteId": obj.id.toString(),
												"engNoteId": obj.engNoteId.toString(),
												"isChanged": 1,
												"isDelete": 0,
												"loginId": this.userLoginId,
												"acctYear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
												"workbookNotesId": this.balanceSheetDetails[i].children[j].children[k].notes[indx].workbooknotesid
											}]
										}
										this.apiService.saveNotesBalanceSheet(payload).subscribe(resp => {
											if (resp && resp == 'Success') {
												this.getBalanceSheetDetails("");
												this.getIncomeStatementDetails("");
												return
											}
										})
									}
								}
								else if (changetype == "draganddrop" || changetype == 'delete') {
									tempary = this.joinMiddleNotesIntoSingleArray();

									for (let l = 0; l < this.balanceSheetDetails[i].children[j].children[k].notes.length; l++) {
										if (changetype == 'delete') {
											if (this.isCategoryDelete) {
												var categoryindx = this.middleNotes.findIndex(x => x.isDelete == true);
												if (categoryindx > -1) {
													if (this.middleNotes[categoryindx].categoryId && this.middleNotes[categoryindx]?.notes) {
														if (this.middleNotes[categoryindx].notes.find(y => y.id == this.balanceSheetDetails[i].children[j].children[k].notes[l].noteid)) {
															this.deletableLinkedNotes.push(this.balanceSheetDetails[i].children[j].children[k].notes[l])
														}
													}
													else if (!this.middleNotes[categoryindx].categoryId && this.middleNotes[categoryindx].id) {
														if (this.middleNotes.find(y => y.id == this.balanceSheetDetails[i].children[j].children[k].notes[l].noteid && y.isDelete == true)) {
															this.deletableLinkedNotes.push(this.balanceSheetDetails[i].children[j].children[k].notes[l])
														}
													}
												}
											}
											else if (this.isSubCategoryDelete) {
												for (let index = 0; index < this.middleNotes.length; index++) {
													if (this.middleNotes[index].notes) {
														if (this.middleNotes[index].notes.find(y => y.id == this.balanceSheetDetails[i].children[j].children[k].notes[l].noteid && y.isDelete == true)) {
															this.deletableLinkedNotes.push(this.balanceSheetDetails[i].children[j].children[k].notes[l])
														}
													}
												}
											}
											else if (this.deleteAll) {
												if (tempary.find(x => x.is_checked == true && x.id == this.balanceSheetDetails[i].children[j].children[k].notes[l].noteid)) {
													this.deletableLinkedNotes.push(this.balanceSheetDetails[i].children[j].children[k].notes[l])
												}
											}
										}
										else if (changetype == "draganddrop") {
											var tempary_obj = tempary.find(y => y.id == this.balanceSheetDetails[i].children[j].children[k].notes[l].noteid)
											if (tempary_obj) {
												let pobj = {
													"engagementsId": this.engagementID,
													"finSubgroupChildId": this.balanceSheetDetails[i].children[j].children[k].notes[l].finsubgroupchildid,
													"finSubgroupId": "",
													"submoduleId": this.balanceSheetDetails[i].children[j].children[k].notes[l].submoduleid,
													"noteName": tempary_obj.name,
													"noteId": tempary_obj.id.toString(),
													"engNoteId": tempary_obj.engNoteId.toString(),
													"isChanged": 1,
													"isDelete": 0,
													"loginId": this.userLoginId,
													"acctYear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
													"workbookNotesId": this.balanceSheetDetails[i].children[j].children[k].notes[l].workbooknotesid
												}
												balancesheetpayload.push(pobj)
											}
										}

									}


								}
							}

						}
					}

				}
			}

		}
		if (changetype == "draganddrop" && balancesheetpayload) {
			if (balancesheetpayload.length > 0)
				this.apiService.saveNotesBalanceSheet({ "save": balancesheetpayload }).subscribe(resp => {
					if (resp && resp == 'Success') {
						this.getBalanceSheetDetails("");
						this.getIncomeStatementDetails("");
					}
				})
		}
	}
	detectChangeInNotesRelatedTostockholders(changetype, obj?) {
		this.stockholderdeletableLinkedNotes = [];
		var stockholderpayload = [];
		var tempary = [];



		if (changetype == 'rename' && obj) {
			const payload = {
				"submoduleId": '924',
				"engagementsId": this.engagementData.engagementsid + '',
				"acctYear": this.datePipe.transform(this.engagementData.yearEnd, 'y'),
				"noteName": obj.name,
				"noteId": obj.id + '',
				"engNoteId": obj.engNoteId + '',
				"isDelete": 'false'
			}
			this.savestockholdersfsnotes([payload]);

		}

		if (changetype == "draganddrop" || changetype == 'delete') {
			tempary = this.joinMiddleNotesIntoSingleArray();

			if (changetype == 'delete') {
				if (this.isCategoryDelete) {
					var categoryindx = this.middleNotes.findIndex(x => x.isDelete == true);
					if (categoryindx > -1) {
						if (this.middleNotes[categoryindx].categoryId) {

							this.middleNotes[categoryindx].engNoteId = -1
							this.stockholderdeletableLinkedNotes.push(this.middleNotes[categoryindx])

						}

						else if (!this.middleNotes[categoryindx].categoryId && this.middleNotes[categoryindx].id) {

							this.middleNotes[categoryindx].engNoteId = -1
							this.stockholderdeletableLinkedNotes.push(this.middleNotes[categoryindx])

						}
					}
				}
				else if (this.isSubCategoryDelete) {
					for (let index = 0; index < this.middleNotes.length; index++) {
						if (this.middleNotes[index].notes) {
							if (this.middleNotes[index].notes.find(y => y.isDelete == true)) {

								this.middleNotes[index].notes[this.middleNotes[index].notes.findIndex(y => y.isDelete == true)].engNoteId = -1
								this.stockholderdeletableLinkedNotes.push(this.middleNotes[index].notes[this.middleNotes[index].notes.findIndex(y => y.isDelete == true)])
							}
						}
					}
				}
				else if (this.deleteAll) {
					const temp2ary = JSON.parse(JSON.stringify(tempary));
					temp2ary.forEach(element => {
						element.isDelete = true;
						element.engNoteId = -1
					});
					this.stockholderdeletableLinkedNotes.push(...temp2ary)

				}
			}
			else if (changetype == "draganddrop") {
				this.savestockholdersfsnotes(tempary)
			}

		}

	}
	savestockholdersfsnotes(tempary) {
		const array = []
		tempary.forEach(obj => {
			const payload = {
				"stockHolderSubmoduleId": this.stockHolderSubmoduleId + '',
				"cashFlowSubModuleId": this.cashFlowSubModuleId + '',
				"engagementsId": this.engagementData.engagementsid + '',
				"acctYear": this.datePipe.transform(this.engagementData.yearEnd, 'y'),
				"noteName": obj.name ? obj.name : obj.noteName,
				"noteId": obj.id ? obj.id : obj.noteId + '',
				"engNoteId": obj.engNoteId + '',
				"isDelete": obj.isDelete + ''
			}
			array.push(payload)
		});

		var pyload = {
			"loginId": this.userLoginId,
			"notes": array,
			"isNotesUpdate": true,
		}
		this.apiService.saveNotesStockholderEquity(pyload).subscribe(resp => {
			if (resp && resp == 'Success') {
			}
		})
	}

	getBalanceSheetDetails(searchTerm) {
		let search = searchTerm ? searchTerm : null;
		var balanceSheetObj = {
			"engagementsid": this.engagementData.engagementsid,
			"acctyear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
			"searchtext": search
		}
    var finalGetObj = JSON.stringify(balanceSheetObj);
	this.updateSpinnerConfig(true);
    this.engApiService.getWFSBalanceSheet(finalGetObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          let data = JSON.parse(res?.data);
          this.balanceSheetDetails = data.groups;
        }
      }, error: e => {
      }
    });
	}

  getIncomeStatementDetails(searchTerm) {
		let search = searchTerm ? searchTerm : null;
    let blsobj = {
			"engagementsid": this.engagementData.engagementsid,
			"acctyear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
			"submoduleid": 437,
			"searchtext": search
		}
    let finalGetObj = JSON.stringify(blsobj);
	this.updateSpinnerConfig(true);
    this.engApiService.getWFSIncomeStatement(finalGetObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          let data = JSON.parse(res?.data);
          this.incomeStatementdetails = data.groups;
        }
      }, error: e => {
      }
    });
	}

	refreshNotes() {
		this.getNotesTrialBalanceData();
	}
	renameObject(i, renametype, j?) {

		var indx = -1;
		var cindx = -1;
		cindx = this.middleNotes.findIndex(x => x.isEdit == true)
		if (cindx == -1) {
			for (let k = 0; k < this.middleNotes.length; k++) {
				if (this.middleNotes[k].notes) {
					indx = this.middleNotes[k].notes.findIndex(x => x.isEdit == true)
					if (indx > -1 || cindx > -1) {
						this.toaster.error("Please save/cancel existing renaming process")
						return
					}
				}

			}
		}
		else if (indx > -1 || cindx > -1) {
			this.toaster.error("Please save/cancel existing renaming process")
			return
		}
		if (renametype == 'category') {
			this.middleNotes[i].isEdit = true;
			this.oldCategoryName = this.middleNotes[i].name
			return
		}
		else if (renametype == 'categorynotes') {
			this.middleNotes[i].notes[j].isEdit = true;
			this.oldSubCategoryName = this.middleNotes[i].notes[j].name;
			return
		}


	}

	saveName(i, j?) {

		if (this.middleNotes[i].name == "" || (typeof j != "undefined" && this.middleNotes[i].notes && this.middleNotes[i].notes[j] && this.middleNotes[i].notes[j].name == "")) {
			this.toaster.error("Missing Name");
			return
		} else {
			this.middleNotes[i].isEdit = false;
			if (this.middleNotes[i].id && !j) {
				this.detectChangeInNotesRelatedToBalancesheet('rename', this.middleNotes[i]);
				this.detectChangeInNotesRelatedToIncomeStatement('rename', this.middleNotes[i]);
			}
			if (j) {
				this.middleNotes[i].notes[j].isEdit = false;
				this.detectChangeInNotesRelatedToBalancesheet('rename', this.middleNotes[i].notes[j])
				this.detectChangeInNotesRelatedToIncomeStatement('rename', this.middleNotes[i].notes[j])
			}
			this.saveMiddleNotes(this.middleNotes);
		}

	}
	deleteLinkedIncomeSheetNotes() {
		if (this.incomesheetdeletableLinkedNotes) {
			var payload = [];
			for (let i = 0; i < this.incomeStatementdetails.length; i++) {
				if (this.incomeStatementdetails[i].children && this.incomeStatementdetails[i].children.length) {
					for (let j = 0; j < this.incomeStatementdetails[i].children.length; j++) {
						if (this.incomeStatementdetails[i].children[j].children && this.incomeStatementdetails[i].children[j].children.length) {
							for (let k = 0; k < this.incomeStatementdetails[i].children[j].children.length; k++) {
								if (this.incomeStatementdetails[i].children[j].children[k].notes) {
									for (let l = 0; l < this.incomeStatementdetails[i].children[j].children[k].notes.length; l++) {
										var checkobjexist = this.incomesheetdeletableLinkedNotes.filter(x => x.noteid == this.incomeStatementdetails[i].children[j].children[k].notes[l].noteid)
										if (checkobjexist.length > 0) {
											for (let L = 0; L < checkobjexist.length; L++) {
												let pobj = {
													"engagementsId": checkobjexist[L].engagementsid,
													"finSubgroupChildId": checkobjexist[L].finsubgroupchildid,
													"finSubgroupId": "",
													"submoduleId": checkobjexist[L].submoduleid,
													"noteName": checkobjexist[L].notename,
													"noteId": checkobjexist[L].noteid,
													"engNoteId": checkobjexist[L].engNoteId,
													"isChanged": 1,
													"isDelete": 1,
													"loginId": this.userLoginId,
													"acctYear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
													"workbookNotesId": checkobjexist[L].workbooknotesid
												}
												payload.push(pobj)
											}
										}

									}
								}
							}
						}
					}
				}
			}
			return payload
		}
	}
	deleteLinkedBalanceSheetNotes() {
		if (this.deletableLinkedNotes) {
			var payload = [];
			for (let i = 0; i < this.balanceSheetDetails.length; i++) {
				if (this.balanceSheetDetails[i].children && this.balanceSheetDetails[i].children.length) {
					for (let j = 0; j < this.balanceSheetDetails[i].children.length; j++) {
						if (this.balanceSheetDetails[i].children[j].children && this.balanceSheetDetails[i].children[j].children.length) {
							for (let k = 0; k < this.balanceSheetDetails[i].children[j].children.length; k++) {
								if (this.balanceSheetDetails[i].children[j].children[k].notes) {
									for (let l = 0; l < this.balanceSheetDetails[i].children[j].children[k].notes.length; l++) {
										var checkobjexist = this.deletableLinkedNotes.filter(x => x.noteid == this.balanceSheetDetails[i].children[j].children[k].notes[l].noteid)
										if (checkobjexist.length > 0) {
											for (let L = 0; L < checkobjexist.length; L++) {
												let pobj = {
													"engagementsId": checkobjexist[L].engagementsid,
													"finSubgroupChildId": checkobjexist[L].finsubgroupchildid,
													"finSubgroupId": "",
													"submoduleId": checkobjexist[L].submoduleid,
													"noteName": checkobjexist[L].notename,
													"noteId": checkobjexist[L].noteid,
													"engNoteId": checkobjexist[L].engNoteId,
													"isChanged": 1,
													"isDelete": 1,
													"loginId": this.userLoginId,
													"acctYear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
													"workbookNotesId": checkobjexist[L].workbooknotesid
												}
												payload.push(pobj)
											}
										}

									}
								}
							}
						}
					}
				}
			}
			return payload
		}
	}

	deleteSelected() {
		for (let i = this.middleNotes.length - 1; i >= 0; i--) {
			if (this.middleNotes[i].is_checked == true) {
				this.middleNotes.splice(i, 1);
			}
			if (this.middleNotes[i] && this.middleNotes[i].notes) {
				for (let j = this.middleNotes[i].notes.length - 1; j >= 0; j--) {
					if (this.middleNotes[i].notes[j].is_checked == true) {
						this.middleNotes[i].notes.splice(j, 1);
					}
				}
			}
		}
		this.reorderEngNoteId('category');
		for (let i = 0; i < this.middleNotes.length; i++) {
			this.middleNotes[i].engNoteId = i + 1;
			if (this.middleNotes[i].notes) {
				for (let j = 0; j < this.middleNotes[i].notes.length; j++) {
					if (j == 0) {
						this.middleNotes[i].notes[j].engNoteId = this.middleNotes[i].engNoteId + '.1';
					}
					else {
						this.middleNotes[i].notes[j].engNoteId = this.middleNotes[i].engNoteId + '.' + (parseInt(this.middleNotes[i].notes[j - 1].engNoteId.split('.')[1]) + 1)
					}
				}
			}

		}
		this.saveMiddleNotes(this.middleNotes);
	}
	deleteSelectedWtihLinkedNotes() {
		if (this.isdelete) {
			var checkLinkedNotesExist = this.deletableLinkedNotes ? true : false;
			if (checkLinkedNotesExist) {
				var payload = this.deleteLinkedBalanceSheetNotes();
				var incomepayload = this.deleteLinkedIncomeSheetNotes();
				if (this.isSelectAll) {
					var pobj = {
						"loginId": this.userLoginId,
						"engagementsId": this.engagementID,
						"acctYear": parseInt(this.datePipe.transform(this.engagementData.yearEnd, 'y')),
					}
					this.apiService.unSaveNotesBalanceSheet(pobj).subscribe(resp => {
						if (resp && resp == 'Success') {
							this.getBalanceSheetDetails("");
							this.getIncomeStatementDetails("");
						}
					})
				} else {
					if (payload && payload.length > 0) {
						this.apiService.saveNotesBalanceSheet({ "save": payload }).subscribe(resp => {
							if (resp && resp == 'Success') {
								this.getBalanceSheetDetails("");
							}
						})
					} if (incomepayload && incomepayload.length > 0) {
						this.apiService.saveNotesBalanceSheet({ "save": incomepayload }).subscribe(resp => {
							if (resp && resp == 'Success') {
								this.getIncomeStatementDetails("");
							}
						})
					}
				}

				this.deleteSelected();
			}
			else {
				this.deleteSelected();
			}
			this.detectChangeInNotesRelatedToBalancesheet('draganddrop')
			this.detectChangeInNotesRelatedToIncomeStatement('draganddrop')
		} else {
			this.toaster.error("Please select atleast on record")
		}
	}
	cancelRename(i, renametype, j?) {
		if (renametype == 'category') {
			this.middleNotes[i].isEdit = false;
			this.middleNotes[i].name = this.oldCategoryName;
			this.oldCategoryName = '';
		}
		else if (renametype == 'categorynotes') {
			this.middleNotes[i].notes[j].isEdit = false;
			this.middleNotes[i].notes[j].name = this.oldSubCategoryName;
			this.oldSubCategoryName = '';
		}
	}

	reorderEngNoteId(reordertype, i?) {
		if (reordertype == 'category') {
			for (let index = 0; index < this.middleNotes.length; index++) {
				this.middleNotes[index].engNoteId = index + 1;
				if (this.middleNotes[index].notes && this.middleNotes[index].notes.length) {
					for (let j = 0; j < this.middleNotes[index].notes.length; j++) {
						if (j == 0) {
							this.middleNotes[index].notes[j].engNoteId = this.middleNotes[index].engNoteId + '.1';
						}
						else {
							this.middleNotes[index].notes[j].engNoteId = this.middleNotes[index].engNoteId + '.' + (parseInt(this.middleNotes[index].notes[j - 1].engNoteId.split('.')[1]) + 1)
						}

					}

				}
			}
		}
		if (reordertype == 'subcategory') {
			if (this.middleNotes[i].notes.length) {
				for (let j = 0; j < this.middleNotes[i].notes.length; j++) {
					if (j == 0) {
						this.middleNotes[i].notes[j].engNoteId = this.middleNotes[i].engNoteId + '.1';
					}
					else {
						this.middleNotes[i].notes[j].engNoteId = this.middleNotes[i].engNoteId + '.' + (parseInt(this.middleNotes[i].notes[j - 1].engNoteId.split('.')[1]) + 1)
					}

				}
			}
		}
	}
	openDeleteDialog(text?, header?) {
		if (!this.isSelectAll) { this.detectChangeInNotesRelatedToBalancesheet('delete'); this.detectChangeInNotesRelatedToIncomeStatement('delete') }
		if (text && header) {
			this.dialogboxText = (header != 'category' && header != 'multiple') ? 'Deleting the note would remove the data permanently. \n Do you want to delete note?' : text;
			this.dialogboxHeader = header;
			this.dialogboxLinkedText = header != 'category' ? (this.deletableLinkedNotes && this.deletableLinkedNotes.length > 1) ? 'Selected notes are referenced in other pages. Deleting these notes will also remove the references.  Would you like to proceed?' : (this.deletableLinkedNotes && this.deletableLinkedNotes.length == 1) ? 'Note ' + "[" + text + "]" + ' is referenced in other pages. Deleting this note will also remove the reference.   Would you like to proceed ?' : '' : text
		}
		const dialogRef = this.dialog.open(this.deleteDialog, {});
		dialogRef.afterClosed().subscribe();
	}
	deleteNote() {
		if (this.isCategoryDelete) {
			let indx = this.middleNotes.findIndex(x => x.isDelete == true)
			if (indx > -1) {
				this.middleNotes.splice(indx, 1);
				this.reorderEngNoteId('category');
			}
			this.isCategoryDelete = false;
		}
		else if (this.isSubCategoryDelete) {
			for (let index = 0; index < this.middleNotes.length; index++) {
				if (this.middleNotes[index].notes) {
					let indx = this.middleNotes[index].notes.findIndex(x => x.isDelete == true);
					if (indx > -1) {
						this.middleNotes[index].notes.splice(indx, 1);
						this.reorderEngNoteId('subcategory', index)
					}
				}
			}
			this.isSubCategoryDelete = false;
		}
		this.saveMiddleNotes(this.middleNotes);
	}
	deleteNoteWithLinkedNotes() {
		var checkLinkedNotesExist = ((this.deletableLinkedNotes && this.deletableLinkedNotes.length) || (this.incomesheetdeletableLinkedNotes && this.incomesheetdeletableLinkedNotes.length)) ? true : false;
		if (checkLinkedNotesExist) {
			// if (confirm("Are you sure you want to delete linked notes too?")) {
			var payload = this.deleteLinkedBalanceSheetNotes();
			var incomepayload = this.deleteLinkedIncomeSheetNotes();
			if (payload) {
				this.apiService.saveNotesBalanceSheet({ "save": payload }).subscribe(resp => {
					if (resp && resp == 'Success') {
						this.getBalanceSheetDetails("");
					}
				})
			}
			if (incomepayload) {
				this.apiService.saveNotesBalanceSheet({ "save": incomepayload }).subscribe(resp => {
					if (resp && resp == 'Success') {
						this.getIncomeStatementDetails("");
					}
				})
			}
			this.deleteNote();
			// }
		}
		else {
			this.deleteNote();
		}
		this.detectChangeInNotesRelatedToBalancesheet('draganddrop')
		this.detectChangeInNotesRelatedToIncomeStatement('draganddrop')

	}
	createNewCategory() {
		if (this.CreateCategoryName && this.CreateCategoryName.trim()) {
			var obj = {}
			var categories = this.middleNotes.filter(x => x.categoryId);
			if (categories && categories.length > 0) {
				var maxCatID = categories.reduce((p, c) => p.categoryId > c.categoryId ? p : c);
				obj['categoryId'] = maxCatID.categoryId + 1;
			}
			else {
				obj['categoryId'] = 2;
			}
			obj['name'] = this.CreateCategoryName
			obj['engNoteId'] = this.middleNotes.length > 0 ? this.middleNotes[this.middleNotes.length - 1].engNoteId + 1 : 1
			obj['isCheckedCategory'] = false
			obj['isExpand'] = false;
			obj['notes'] = [];
			this.middleNotes.push(obj);
			this.saveMiddleNotes(this.middleNotes, "add category");
		} else { this.toaster.error('Please enter valid name') }
	}
	openCreateCategoryDialog() {
		this.CreateCategoryName = '';
		const dialogRef = this.dialog.open(this.createCategoryDialog, {});
		dialogRef.afterClosed().subscribe();
	}
	resetNotesBooleanValues(data) {
		data.forEach(element => {
			element.isCheckedCategory = false;
			element.isExpand = false;
			element['highlight'] = false;
			if (element.notes && element.notes.length > 0) {
				element.notes.forEach(el => {
					el.isNotesChecked = false;
					el.isExpand = false;
					el['highlight'] = false;
				});
			}
			if (element.subcategories && element.subcategories.length > 0) {
				element.subcategories.forEach(ele => {
					ele.isSubcategoryChecked = false;
					ele.isExpand = false;
					ele['highlight'] = false;
					if (ele.notes && ele.notes.length > 0) {
						ele.notes.forEach(e => {
							e.isNotesChecked = false;
							e.isExpand = false;
							e['highlight'] = false;
						});
					}
				});
			}
		});
	}
	addBelongsProperty(data) {
		data.forEach(category => {
			if (category.notes && category.notes.length > 0) {
				category.notes.forEach(note => {
					note['belongsto'] = category.categoryId
				});
			}
			if (category.subcategories && category.subcategories.length > 0) {
				category.subcategories.forEach(subcat => {
					if (subcat.notes && subcat.notes.length > 0) {
						subcat.notes.forEach(note => {
							note['belongsto'] = category.categoryId
						});
					}
				});
			}
		});
	}
	getFirmTemplatesNotesToFs() {
		let jsonFileName = this.firmUserAcctId + "_FirmTemplate.json";
		const uploadObj = {
			"module": modules[19],
			"firmId": this.firmUserAcctId,
			"status": 0,
			"folderName": jsonFileName,
			"appSyncId": this.userLoginId,
			"extension": 'comp',
		}

		this.updateSpinnerConfig(true);
		this.apiService.getJsonData(uploadObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
			if (response) {
				var tempnotes = response ? JSON.parse(response) : [];
				this.addBelongsProperty(tempnotes)
				// console.log('tempnotes', tempnotes)
				if (this.isUpdateNotes) {
					if (tempnotes && tempnotes.length > 0 && this.isUpdateNotesObj.categoryId != 1 && tempnotes.findIndex(x => x.categoryId == 1) > -1) {
						tempnotes.splice(tempnotes.findIndex(x => x.categoryId == 1), 1)
					}
					else if (this.isUpdateNotesObj.categoryId == 1) {
						tempnotes = tempnotes.filter(x => x.categoryId == 1)
					}
				}
				this.notes = tempnotes
				this.resetNotesBooleanValues(this.notes);
				this.allNotesCheked = false;
				this.notesCount = 0;
				this.totalNotesCount = this.calculateNotesCount(true);
			}
		}, error => {
		});
	}
	notesFSImportSelectionDialogFunc(input, isUpdateNotes?: boolean, index?) {
		this.isUpdateNotes = isUpdateNotes ? true : false;
		this.notesSRC = input;
		this.allNotesCheked = false;
		this.notesCount = 0;
		this.notes = [];
		this.searchText = '';
		this.isUpdateNotesObj = this.middleNotes[index]
		this.notesIndex = index;
		if (this.notesSRC == 0) {
			this.getFirmTemplatesNotesToFs()
		} else {
			this.getNotesPath();
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.height = '100%';
		dialogConfig.position = { 'top': '53px', right: '0' };
		const dialogRef = this.dialog.open(this.notesFSImportSelectionDialogTemp, dialogConfig);
		dialogRef.afterClosed().subscribe();
	}
	onChangeFrom(event) {
		this.searchText = '';
		this.notesSRC = event;
		this.notes = [];
		if (this.notesSRC == 0) {
			this.getFirmTemplatesNotesToFs();
		} else {
			this.getNotesPath();
		}
	}

	getTBLSHeaderNotes() {
    let engId = this.engagementData.engagementsid;
    let subModuleId = this.workBookSubModuleId;

    this.wbService.getWbHeaderNote(engId, subModuleId).subscribe({
      next: res => {
        if (res?.status === 200 && res?.data) {
          let results = JSON.parse(res?.data);
          this.headerNotesColumn1 = results[0].header[0].changednameline1;
          this.headerNotesColumn2 = results[0].header[0].changednameline2;
          this.headerNotesColumn3 = results[0].header[0].changednameline3;
          this.sharedService.isFsNotesHeaderUpdate.next(results);

        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
	}

	cancelDelete() {
		this.deletableLinkedNotes = [];
		if (this.isCategoryDelete) {
			let indx = this.middleNotes.findIndex(x => x.isDelete == true)
			if (indx > -1) {
				this.middleNotes[indx].isDelete = false;
			}
			this.isCategoryDelete = false;

		}
		else if (this.isSubCategoryDelete) {
			for (let index = 0; index < this.middleNotes.length; index++) {
				if (this.middleNotes[index].notes) {
					let indx = this.middleNotes[index].notes.findIndex(x => x.isDelete == true);
					if (indx > -1) {
						this.middleNotes[index].notes[indx].isDelete = false;
					}
				}
			}
			this.isSubCategoryDelete = false;

		}
		else if (this.deleteAll) {
			this.isSelectAll = false;
			this.deleteAll = false;
			this.middleNotes.forEach(element => {
				element.is_checked = false;
				if (element.notes) {
					element.notes.forEach(ele => {
						ele.is_checked = false;
					});
				}
			})
		}
		this.isdelete = this.isSelectedMorethanTwo() > 1
	}

	saveHeaderNote() {
    const headerNameModel: HeaderNameModel = {
      subModuleId: this.workBookSubModuleId,
      engId: this.engagementData.engagementsid,
      changedNameLine2: this.headerNotesColumn2,
      changedNameLine3: this.headerNotesColumn3,
      isDelete: 0
    };

    this.updateSpinnerConfig(true);
    this.wbService.saveChangeWbHeaderName(headerNameModel).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.toaster.success('Header details updated successfully');
          this.isSecondColumnClicked = false;
          this.isThirdColumnClicked = false;
          this.getTBLSHeaderNotes();
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
	}

  getNotesPath() {
		//1::master library,0::firm templates ::: this.notesSRC

		//todo
		//countryId needs to be intialised.
		//if usa, return a json with string jsonFileName and jsonFilePath
		//if reponse, call getNotesPath within

		if (this.countryId == 226 && this.notesSRC == 1) {
			this.updateSpinnerConfig(true);
			this.apiService.getUSNotesPath(this.userLoginId, this.countryId).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
				if (response) {
					this.getNotes(response)
				}
				else {
				}
			},
				error => {
				});
		}
		else {
			this.updateSpinnerConfig(true);
			this.noteService.getNotesPath(this.userLoginId, this.notesSRC).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
				const responseData = JSON.parse(response);
				if (responseData) {
					this.getNotes(responseData['jsonFilePath'])
				} else {
				}
			}, error => {
			});
		}
	}
	getNotes(url) {
		let fileName = url.split("/");
		const uploadObj = {
			"module": modules[17],
			"firmId": this.firmUserAcctId,
			"clientId": this.selectedEngagement.clientfirmid,
			"engagementId": this.selectedEngagement.engagementsid,
			"status": 0,
			"folderName": fileName[fileName.length - 1],
			"extension": 'comp',
			"appSyncId": this.userLoginId,
			"partnerId": this.countryId //used for countryId
		}
		this.updateSpinnerConfig(true);
		this.apiService.getJsonData(uploadObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
			var tempnotes = response ? JSON.parse(response) : [];
			this.addBelongsProperty(tempnotes)
			// console.log('tempnotes', tempnotes)

			if (this.isUpdateNotes) {
				if (tempnotes && tempnotes.length > 0 && this.isUpdateNotesObj.categoryId != 1 && tempnotes.findIndex(x => x.categoryId == 1) > -1) {
					tempnotes.splice(tempnotes.findIndex(x => x.categoryId == 1), 1)
				}
				else if (this.isUpdateNotesObj.categoryId == 1) {
					tempnotes = tempnotes.filter(x => x.categoryId == 1)
				}
			}
			this.notes = tempnotes;
			this.resetNotesBooleanValues(this.notes);
			this.allNotesCheked = false;
			this.notesCount = 0;
			this.totalNotesCount = this.calculateNotesCount(true);

		}, (error) => {
			this.notes = [];
			this.notes.forEach(x => {
				if (x.notes) {
					x.notes.forEach(y => {
						x.isExpand = false;
					});
				}
			});
		});
	}

	handleSearch(searchTerm: string) {
		this.notesToFsSubject.next(searchTerm);
	}

	handleMdSearch(searchTerm: string) {
		this.notesMdSubject.next(searchTerm);
	}

	getSearchedDetails() {
		this.notes.forEach(x => {
			if (this.searchText != "") {
				if (x.name.toLowerCase().includes(this.searchText.toLowerCase())) {
					x.isExpand = true;
					x['highlight'] = true;
				} else {
					x.isExpand = false;
					x['highlight'] = false;

				}
			} else {
				x.isExpand = false;
				x['highlight'] = false;

			}

			if (x.notes) {
				x.notes.forEach(y => {
					if (this.searchText != "") {
						if (y.name.toLowerCase().includes(this.searchText.toLowerCase())) {
							x.isExpand = true;
							y.isExpand = true;
							y['highlight'] = true;

						} else {
							// y.isExpand = false;
							y['highlight'] = false;
							// x.isExpand = false;
						}
					} else {
						x.isExpand = false;
						y.isExpand = false;
						y['highlight'] = false;
					}
				});
			}

			if (x.subcategories) {
				x.subcategories.forEach(subCategories => {
					if (this.searchText != "") {
						if (subCategories.name.toLowerCase().includes(this.searchText.toLowerCase())) {
							x.isExpand = true;
							subCategories.isExpand = true;
							subCategories['highlight'] = true;
						}
						else {
							// x.isExpand = false;
							// subCategories.isExpand = false;
							subCategories['highlight'] = false;
						}
					} else {
						x.isExpand = false;
						subCategories.isExpand = false;
						subCategories['highlight'] = false;
					}

					if (subCategories.notes) {
						subCategories.notes.forEach(subNotes => {
							if (this.searchText != "") {
								if (subNotes.name.toLowerCase().includes(this.searchText.toLowerCase())) {
									x.isExpand = true;
									subCategories.isExpand = true;
									subNotes.isExpand = true;
									subNotes['highlight'] = true;
								} else {
									// x.isExpand = false;
									// subCategories.isExpand = false;
									// subNotes.isExpand = false;
									subNotes['highlight'] = false;
								}
							} else {
								x.isExpand = false;
								subCategories.isExpand = false;
								subNotes.isExpand = false;
								subNotes['highlight'] = false;
							}
						});
					} else {
						x.isExpand = false;
						subCategories.isExpand = false;
						x['highlight'] = true;
						subCategories['highlight'] = true;
					}
				});
			}
		});
	}

	getMiddleSearchedDetails() {
		this.middleNotes.forEach(x => {
			if (this.searchMdText != "") {
				if (x.name.toLowerCase().includes(this.searchMdText.toLowerCase())) {
					// x.isExpand = true;
					x['highlight'] = true;
				} else {
					x['highlight'] = false;
				}
			} else {
				x['highlight'] = false;
			}

			if (x.notes) {
				x.notes.forEach(y => {
					if (this.searchMdText != "") {
						if (y.name.toLowerCase().includes(this.searchMdText.toLowerCase())) {
							x.isExpand = true;
							y['highlight'] = true;
						} else {
							x['highlight'] = false;
						}
					} else {
						x.isExpand = false;
						x['highlight'] = false;
					}
				});
			}

			if (x.subcategories) {
				x.subcategories.forEach(subCategories => {
					if (this.searchMdText != "") {
						if (subCategories.name.toLowerCase().includes(this.searchMdText.toLowerCase())) {
							x.isExpand = true;
							subCategories['highlight'] = true;
						} else {
							subCategories['highlight'] = false;
						}
					} else {
						x.isExpand = false;
						subCategories['highlight'] = false;
					}

					if (subCategories.notes) {
						subCategories.notes.forEach(subNotes => {
							if (this.searchMdText != "") {
								if (subNotes.name.toLowerCase().includes(this.searchMdText.toLowerCase())) {
									x.isExpand = true;
									subCategories.isExpand = true;
									subNotes['highlight'] = true;
								} else {
									subNotes['highlight'] = false;
								}
							} else {
								x.isExpand = false;
								subCategories.isExpand = false;
								subNotes['highlight'] = false;
							}
						});
					} else {
						x.isExpand = false;
						subCategories.isExpand = false;
						subCategories['highlight'] = false;
					}
				});
			}
		});
	}

	trackByRecords(index, item) {
		return index; // or item.id
	}
	trackByCategoryNotes(index, item) {
		return index;
	}
	trackBySubCategoryNotes(index, item) {
		return index;
	}
	multiCheck() {
		this.notes.forEach(c => {
			if (this.allNotesCheked) {
				c.isCheckedCategory = true;
				if (c.subcategories) {
					c.subcategories.forEach(sc => {
						if (c.isCheckedCategory) {
							sc.isSubcategoryChecked = true;
							if (sc.notes) {
								sc.notes.forEach(n => {
									if (sc.isSubcategoryChecked)
										n.isNotesChecked = true;
								})
							}
						}
					})
				}
				if (c.notes) {
					c.notes.forEach(n => {
						if (c.isCheckedCategory)
							n.isNotesChecked = true;
					})
				}
			}
			else {
				c.isCheckedCategory = false;
				if (c.subcategories) {
					c.subcategories.forEach(sc => {
						if (!c.isCheckedCategory) {
							sc.isSubcategoryChecked = false;
							if (sc.notes) {
								sc.notes.forEach(n => {
									if (!sc.isSubcategoryChecked)
										n.isNotesChecked = false;
								})
							}
						}
					})
				}
				if (c.notes) {
					c.notes.forEach(n => {
						if (!c.isCheckedCategory)
							n.isNotesChecked = false;
					})
				}
			}
		})
		this.notesCount = this.calculateNotesCount();
	}
	singleCheck(from: 'category' | 'subCategory' | 'categoryNotes' | 'subCategoryNotes', isChecked, data, parentData?) {
		if (from === 'category') {
			if (data.subcategories) {
				data.subcategories.forEach(sc => {
					if (isChecked) {
						sc.isSubcategoryChecked = true;
						if (sc.notes) {
							sc.notes.forEach(n => {
								n.isNotesChecked = true;
							})
						}
					}
					else {
						sc.isSubcategoryChecked = false;
						if (sc.notes) {
							sc.notes.forEach(n => {
								n.isNotesChecked = false;
							})
						}
					}

				})
			}
			if (data.notes) {
				data.notes.forEach(n => {
					if (isChecked)
						n.isNotesChecked = true;
					else
						n.isNotesChecked = false;
				})
			}
		}
		else if (from === 'subCategory') {
			if (data) {
				let subCategoryLength = parentData.subcategories.length;
				let subCategoryCheckedLength = parentData.subcategories.filter(n => n.isSubcategoryChecked).length;
				if (subCategoryLength === subCategoryCheckedLength)
					parentData.isCheckedCategory = true;
				else
					parentData.isCheckedCategory = false;
				if (data.notes) {
					data.notes.forEach(n => {
						if (isChecked)
							n.isNotesChecked = true;
						else
							n.isNotesChecked = false;
					})
				}
			}

		}
		else if (from === 'subCategoryNotes') {
			if (data.notes) {
				let notesLength = data.notes.length;
				let notesCheckedLength = data.notes.filter(n => n.isNotesChecked).length;
				if (notesLength === notesCheckedLength)
					data.isSubcategoryChecked = true;
				else
					data.isSubcategoryChecked = false;
				let subCategoryLength = parentData.subcategories.length;
				let subCategoryCheckedLength = parentData.subcategories.filter(n => n.isSubcategoryChecked).length;
				if (subCategoryLength === subCategoryCheckedLength)
					parentData.isCheckedCategory = true;
				else
					parentData.isCheckedCategory = false;
			}
		}
		else if (from === 'categoryNotes') {
			if (data.notes) {
				let notesLength = data.notes.length;
				let notesCheckedLength = data.notes.filter(n => n.isNotesChecked).length;
				if (notesLength === notesCheckedLength)
					data.isCheckedCategory = true;
				else
					data.isCheckedCategory = false;
			}
		}
		this.notesCount = this.calculateNotesCount();
		this.allNotesCheked = this.totalNotesCount === this.notesCount ? true : false;
	}
	calculateNotesCount(defaultCall?) {
		let catNotesCheckArray = [], subCatNotesCheckArray = [];
		this.notes.forEach((c, i) => {
			if (this.isUpdateNotes) {
				if (c.notes && c.notes.length > 0) {
					c.notes.forEach(cn => {
						if (cn.isNotesChecked)
							catNotesCheckArray.push(cn.id);
						if (defaultCall)
							catNotesCheckArray.push(cn.id);
					})
				}
				else if (c.subcategories && c.subcategories.length > 0) {
					c.subcategories.forEach(csn => {
						if (csn.notes && csn.notes.length > 0) {
							csn.notes.forEach(cn => {
								if (cn.isNotesChecked)
									catNotesCheckArray.push(cn.id);
								if (defaultCall)
									catNotesCheckArray.push(cn.id);
							})
						}
					});
				}
			}
			if (!this.isUpdateNotes) {
				if (c.notes) {
					c.notes.forEach(cn => {
						if (cn.isNotesChecked)
							catNotesCheckArray.push(cn.id);
						if (defaultCall)
							catNotesCheckArray.push(cn.id);
					})
				}
				if (c.subcategories) {
					c.subcategories.forEach(sc => {
						if (sc.notes) {
							sc.notes.forEach((sn) => {
								if (sn.isNotesChecked)
									subCatNotesCheckArray.push(sn.id);
								if (defaultCall)
									catNotesCheckArray.push(sn.id);
							});
						}
					})
				}
			}
		})
		return catNotesCheckArray.length + subCatNotesCheckArray.length;
	}
	async addNotes() {
		var selectednotes = [], categoryOneObj = {}, saveSelected = [], temparray = [];
		if (!this.isUpdateNotes && this.notes.findIndex(x => x.categoryId == 1) > -1) {
			categoryOneObj = JSON.parse(JSON.stringify(this.notes.find(x => x.categoryId == 1)));
			categoryOneObj['notes'] = [];
			categoryOneObj['subcategories'] = [];
		}
		this.notes.forEach(element => {
			if (element.isCheckedCategory) {
				if (element.subcategories && element.subcategories.length > 0) {
					element.subcategories.forEach(subcategory => {
						if (subcategory.notes && subcategory.notes.length > 0) {
							subcategory.notes.forEach(note => {
								selectednotes.push(note)
							});
						}
					});

				}
				if (element.notes && element.notes.length > 0) {
					element.notes.forEach(note => {
						selectednotes.push(note)
					});
				}

			} else if (element.subcategories && element.subcategories.length > 0 && element.subcategories.findIndex(x => x.isSubcategoryChecked == true) > -1) {
				element.subcategories.filter(x => x.isSubcategoryChecked == true).forEach(subcat => {
					if (subcat.notes && subcat.notes.length > 0) {
						subcat.notes.forEach(note => {
							selectednotes.push(note)
						});
					}

				});
			}
			else if (element.notes && element.notes.length > 0 && element.notes.findIndex(x => x.isNotesChecked == true) > -1) {
				element.notes.forEach(note => {
					if (note.isNotesChecked) {
						selectednotes.push(note)
					}
				});
			} else if (element.subcategories && element.subcategories.length > 0 && element.subcategories.findIndex(x => x.isSubcategoryChecked == true) == -1) {
				element.subcategories.forEach(sub => {
					if (sub.notes && sub.notes.length > 0 && sub.notes.findIndex(x => x.isNotesChecked == true) > -1) {
						sub.notes.forEach(note => {
							if (note.isNotesChecked) {
								selectednotes.push(note)
							}
						});
					}
				});
			}
		});
		var autoNoteData = [];
		const autoNoteExists = selectednotes.filter(ele => ele.isAutomated).length;
		if (autoNoteExists) {
			await this.getPPENoteData().then(response => {
				autoNoteData = JSON.parse(JSON.stringify(response));
			});
		}
		if (!this.isUpdateNotes) {
			selectednotes.forEach(element => {
				var obj = {
					'isNotesChecked': false,
					'name': element.name,
					'content': element.content,
					'id': this.apiService.makeId(8),
					'originalItems': element.content ? JSON.parse(JSON.stringify(element.content)) : [],
					'items': element.content ? JSON.parse(JSON.stringify(element.content)) : [],
					'originalSectionsArray': element.content ? element.content.map(val => { return { type: val.type, id: val.id }; }) : [],
					'sectionsArray': element.content ? element.content.map(val => { return { type: val.type, id: val.id }; }) : [],
				}
				if (element.isAutomated) {
					obj['isAutomated'] = element.isAutomated;
					obj.content[0].rows = [];
					autoNoteData.forEach((val, index) => {
						let valuesObj = [
							{ colId: "cost", tbValue: val.cost, colValue: ((val.cost || 0) < 0) ? this.roundUpNegativeValue((val.cost || 0)) : Math.round((val.cost || 0)) },
							{ colId: "amortization", tbValue: val.amortizationFinalAmount, colValue: ((val.amortizationFinalAmount || 0) < 0) ? this.roundUpNegativeValue(val.amortizationFinalAmount || 0) : Math.round(val.amortizationFinalAmount || 0) },
							{ colId: "currYear", tbValue: val.netBookValue, colValue: ((val.netBookValue || 0) < 0) ? this.roundUpNegativeValue((val.netBookValue || 0)) : Math.round((val.netBookValue || 0)) },
							{ colId: "priorYear", tbValue: val.py1NetBookValue, colValue: ((val.py1NetBookValue || 0) < 0) ? this.roundUpNegativeValue((val.py1NetBookValue || 0)) : Math.round((val.py1NetBookValue || 0)) },
						];
						let row = {
							isHide: false,
							name: val.accountName,
							trialBalanceId: val.trialBalanceId,
							rowId: (val.accountName === 'Total') ? 'totalrow' : (index + 1).toString(),
							values: (val.accountName === 'Total') ? [] : valuesObj
						}
						obj.content[0].rows.push(row);
					})
				}

				if (element.belongsto == 1 && this.middleNotes.findIndex(x => x.categoryId == 1) > -1) {
					var catIndex = this.middleNotes.findIndex(x => x.categoryId == 1)
					obj['engNoteId'] = this.middleNotes[catIndex].engNoteId + '.' + (parseInt(this.middleNotes[catIndex].notes[this.middleNotes[catIndex].notes.length - 1].engNoteId.split('.')[1]) + 1)
					this.middleNotes[catIndex].notes.push(obj)
				} else if (element.belongsto == 1 && this.middleNotes.findIndex(x => x.categoryId == 1) == -1) {
					categoryOneObj['engNoteId'] = this.middleNotes.length + 1
					obj['engNoteId'] = categoryOneObj['engNoteId'] + "." + 1
					categoryOneObj['notes'].push(obj)
					this.middleNotes.push(categoryOneObj)
				}
				else {
					obj['engNoteId'] = this.middleNotes.length == 0 ? 1 : this.middleNotes[this.middleNotes.length - 1].engNoteId + 1;
					this.middleNotes.push(obj)
				}


			});

		}
		else if (this.isUpdateNotes) {
			selectednotes.forEach(element => {
				var obj = {
					'isNotesChecked': false,
					'name': element.name,
					'content': element.content,
					'id': this.apiService.makeId(8),
					'originalItems': element.content ? JSON.parse(JSON.stringify(element.content)) : [],
					'items': element.content ? JSON.parse(JSON.stringify(element.content)) : [],
					'originalSectionsArray': element.content ? element.content.map(val => { return { type: val.type, id: val.id }; }) : [],
					'sectionsArray': element.content ? element.content.map(val => { return { type: val.type, id: val.id }; }) : [],
				}
				if (element.isAutomated) {
					obj['isAutomated'] = element.isAutomated;
					obj.content[0].rows = [];
					autoNoteData.forEach((val, index) => {
						let valuesObj = [
							{ colId: "cost", tbValue: val.cost, colValue: ((val.cost || 0) < 0) ? this.roundUpNegativeValue((val.cost || 0)) : Math.round((val.cost || 0)) },
							{ colId: "amortization", tbValue: val.amortizationFinalAmount, colValue: ((val.amortizationFinalAmount || 0) < 0) ? this.roundUpNegativeValue(val.amortizationFinalAmount || 0) : Math.round(val.amortizationFinalAmount || 0) },
							{ colId: "currYear", tbValue: val.netBookValue, colValue: ((val.netBookValue || 0) < 0) ? this.roundUpNegativeValue((val.netBookValue || 0)) : Math.round((val.netBookValue || 0)) },
							{ colId: "priorYear", tbValue: val.py1NetBookValue, colValue: ((val.py1NetBookValue || 0) < 0) ? this.roundUpNegativeValue((val.py1NetBookValue || 0)) : Math.round((val.py1NetBookValue || 0)) },
						];
						let row = {
							isHide: false,
							name: val.accountName,
							trialBalanceId: val.trialBalanceId,
							rowId: (val.accountName === 'Total') ? 'totalrow' : (index + 1).toString(),
							values: (val.accountName === 'Total') ? [] : valuesObj
						}
						obj.content[0].rows.push(row);
					})
				}
				obj['engNoteId'] = this.middleNotes[this.notesIndex].engNoteId + '.' + (this.middleNotes[this.notesIndex].notes.length ? parseInt(this.middleNotes[this.notesIndex].notes[this.middleNotes[this.notesIndex].notes.length - 1].engNoteId.split('.')[1]) + parseInt('1') : 1);
				this.middleNotes[this.notesIndex].notes.push(obj);
			});
		}
		// console.log(this.middleNotes)
		localStorage.setItem('NotesExists', this.middleNotes.length == 0 ? 'false' : 'true');
		this.notesFsDataUpdate('add');
	}
	updatePopupNotes() {
		let catNotesCount: number, catNotesCount2: number, catNotes = [], catArray = [], catSquence, subCatSequence, catSequence, selectedNotes = [];
		let notesIndex = this.middleNotes.findIndex(m => m.notes);
		catNotesCount = notesIndex != -1 ? this.middleNotes[notesIndex].notes.length : 0;
		this.notes.forEach((ele, j) => {
			if (ele.categoryId == 1) {
				this.middleNotes.forEach((m, i) => {
					if (notesIndex == i) {
						catSquence = catNotesCount ? +m.notes[catNotesCount - 1]["sequenceCount"] : 0;
						if (ele.notes) {
							let count = catSquence;
							let count1 = m.notes[catNotesCount - 1]["sequenceId"];
							catSquence = +m.notes[catNotesCount - 1]["engNoteId"];
							ele.notes.forEach(pn => {
								if (pn.isNotesChecked) {
									if (m.notes) {
										count += 0.1;
										count1 += 0.01;
										if (count <= 2) {
											catSquence += 0.1;
											pn.engNoteId = catSquence.toFixed(1);
											pn["sequenceId"] = +count1.toFixed(2);
											pn["sequenceCount"] = +count.toFixed(1);
											pn.id = this.apiService.makeId(8);
											m.notes.push(pn);
										}
										else if (count > 2) {
											pn.engNoteId = parseFloat(count1).toFixed(2);
											pn["sequenceId"] = +count1.toFixed(2);
											pn["sequenceCount"] = +count.toFixed(1);
											pn.id = this.apiService.makeId(8);
											m.notes.push(pn);
										}
									}
								}
							})
						}
					}
				})
				catNotesCount2 = ele.notes.filter(e => e.isNotesChecked).length;
				if (catNotesCount == 0) {
					if (ele.notes) {
						if (catNotesCount2) {
							catArray = [{
								"engNoteId": this.middleNotes[this.middleNotes.length - 1]["engNoteId"] + 1,
								"tempId": this.middleNotes[this.middleNotes.length - 1]["engNoteId"] + 1,
								"categoryId": ele.categoryId,
								"isCheckedCategory": ele.isCheckedCategory,
								"isExpand": ele.isExpand,
								"name": ele.name
							}]
							let count;
							let count1;

							count = 1;
							count1 = this.middleNotes[this.middleNotes.length - 1]["engNoteId"] + 1;

							ele.notes.forEach(n => {
								if (n.isNotesChecked) {
									count += 0.1;
									count1 += 0.01;
									if (count <= 2) {
										catArray[j]["tempId"] += 0.1;
										n.engNoteId = parseFloat(catArray[j]["tempId"]).toFixed(1);
										n["sequenceId"] = +count1.toFixed(2)
										n["sequenceCount"] = +count.toFixed(1)
										n.id = this.apiService.makeId(8);
										catNotes.push(n);
									}
									else if (count > 2) {
										n.engNoteId = parseFloat(count1).toFixed(2);
										n["sequenceId"] = +count1.toFixed(2);
										n["sequenceCount"] = +count.toFixed(1);
										n.id = this.apiService.makeId(8);
										catNotes.push(n);
									}
								}
								else if (count > 2 && n.isNotesChecked) {
									n.engNoteId = parseFloat(count1).toFixed(2);
									n.id = this.apiService.makeId(8);
									catNotes.push(n);
								}
							});
							delete catArray[j]["tempId"];
							catArray[j]["notes"] = catNotes;
						};

					}
				}
			}
			else {
				if (ele.subcategories) {
					ele.subcategories.forEach(s => {
						subCatSequence = selectedNotes.length > 0 ? selectedNotes[selectedNotes.length - 1]['engNoteId'] : catNotes.length > 0 ? catArray[0]['engNoteId'] : this.middleNotes.length ? this.middleNotes[this.middleNotes.length - 1]["engNoteId"] : 0;
						s.notes.forEach(n => {
							if (n.isNotesChecked === true) {
								subCatSequence += 1;
								n.engNoteId = +subCatSequence.toFixed(1);
								n.id = this.apiService.makeId(8);
								selectedNotes.push(n);
							}
						});
					})
				}
				if (ele.notes) {
					catSequence = selectedNotes.length > 0 ? selectedNotes[selectedNotes.length - 1]['engNoteId'] : subCatSequence;
					ele.notes.forEach(n => {
						if (n.isNotesChecked === true) {
							catSequence += 1;
							n.engNoteId = +catSequence.toFixed(1);
							n.id = this.apiService.makeId(8);
							selectedNotes.push(n);
						}
					});
				}
			}
		})
		this.middleNotes.push(...catArray, ...selectedNotes);
		this.saveMiddleNotes(this.middleNotes, "update");
	}
	selectAll(event) {
		for (let index = 0; index < this.middleNotes.length; index++) {
			this.middleNotes[index].is_checked = event.checked
			if (this.middleNotes[index].notes) {
				this.middleNotes[index].notes.forEach(element => {
					element.is_checked = event.checked
				});
			}
		}
		this.isdelete = this.isSelectedMorethanTwo() > 1 ? true : false

	}
	is_recordChecked(i, checkedType, j?) {
		if (checkedType == "category") {
			this.middleNotes[i].is_checked = !this.middleNotes[i].is_checked;
			if (this.middleNotes[i].notes) {
				this.middleNotes[i].notes.forEach(element => {
					element.is_checked = this.middleNotes[i].is_checked == true ? true : false
				});
			}
			this.isdelete = this.isSelectedMorethanTwo() > 1 ? true : false
			this.isSelectAll = this.middleNotes.findIndex(x => x.is_checked == false) < 0 ? true : false
		} else if (checkedType == "subcategory") {
			this.middleNotes[i].notes[j].is_checked = !this.middleNotes[i].notes[j].is_checked;
			this.middleNotes[i].is_checked = this.middleNotes[i].notes.findIndex(x => x.is_checked == false) < 0 ? true : false
			this.isSelectAll = this.middleNotes.findIndex(x => x.is_checked == false) < 0 ? true : false
			this.isdelete = this.isSelectedMorethanTwo() > 1 ? true : false

		}
	}
	isSelectedMorethanTwo() {
		var count = 0;
		for (let index = 0; index < this.middleNotes.length; index++) {
			if (this.middleNotes[index].is_checked == true) {
				count = count + 1;
			}
			if (this.middleNotes[index].notes)
				this.middleNotes[index].notes.forEach(element => {
					if (element.is_checked == true) {
						count = count + 1;
					}
				});

		}
		return count
	}
	getMiddleNotes(middleNotesOld?: any) {
		this.isSelectAll = false;
		this.isdelete = false;
		this.deleteAll = false;
		let findExistingEngData = [];
		let jsonFileName = this.engagementID + '_notes.json';
		const uploadObj = {
			"module": modules[16],
			"firmId": this.firmUserAcctId,
			"clientId": this.selectedEngagement.clientfirmid,
			"engagementId": this.selectedEngagement.engagementsid,
			"status": 0,
			"folderName": jsonFileName,
			"appSyncId": this.userLoginId,
			"extension": 'comp',
		}
		this.updateSpinnerConfig(true);
		this.apiService.getJsonData(uploadObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
			this.middleNotes = !response ? [] : JSON.parse(response);
			localStorage.setItem('NotesExists', this.middleNotes.length == 0 ? 'false' : 'true')
			this.sharedService.updateWorkBookPreview.next(true);
			let childId = [], parentId = [];
			this.searchMdText = '';
			this.middleNotes.forEach((ele, j) => {
				ele['isEdit'] = false;
				ele['isDelete'] = false;
				ele['is_checked'] = false;
				ele['highlight'] = false;
				ele['isExpand'] = middleNotesOld && middleNotesOld?.length ? middleNotesOld[j]?.isExpand : false;
				ele['isEditorOpen'] = false;
				if ((ele?.content && Array.isArray(ele?.content)) || ((ele?.notes && Array.isArray(ele?.notes)))) {
					if (!ele.notes) {
						if (ele.content && ele.content.length) {
							ele['originalSectionsArray'] = ele.content.map(val => {
								return { type: val.type, id: val.id };
							});
							ele['sectionsArray'] = ele.content.map(val => {
								return { type: val.type, id: val.id };
							});
							ele?.content.forEach(c => {
								findExistingEngData.push(c.hasOwnProperty('jsonUpdated'));
							});
							ele['originalItems'] = JSON.parse(JSON.stringify(ele.content));
							ele['items'] = JSON.parse(JSON.stringify(ele.content));
						} else {
							ele['originalItems'] = [];
							ele['items'] = [];
							ele['originalSectionsArray'] = [];
							ele['sectionsArray'] = [];
						}
					}
					if (ele.notes) {
						childId = ele.notes.map(ele => ele.engNoteId)
						ele.notes.forEach((element, subInd) => {
							element['isEdit'] = false;
							element['isDelete'] = false;
							element['is_checked'] = false;
							element['highlight'] = false;
							element['isExpand'] = middleNotesOld && middleNotesOld?.length && middleNotesOld[j]?.notes?.length ? middleNotesOld[j].notes[subInd]?.isExpand : false;
							element['isEditorOpen'] = false;
							if (element.content && element.content.length) {
								element['originalSectionsArray'] = element.content.map(val => {
									return { type: val.type, id: val.id };
								});
								element['sectionsArray'] = element.content.map(val => {
									return { type: val.type, id: val.id };
								});
								element?.content.forEach(c => {
									findExistingEngData.push(c.hasOwnProperty('jsonUpdated'));
								});
								element['originalItems'] = JSON.parse(JSON.stringify(element.content));
								element['items'] = JSON.parse(JSON.stringify(element.content));
							} else {
								element['originalItems'] = [];
								element['items'] = [];
								element['originalSectionsArray'] = [];
								element['sectionsArray'] = [];
							}
						});
					}
					if (ele?.items?.length) {
						ele?.items.forEach(c => {
							findExistingEngData.push(c.hasOwnProperty('jsonUpdated'));
						});
					}
        } else {
					if (ele.content && ele.content.length) {
						const notesData = JSON.parse(JSON.stringify(ele.content));
						ele['originalSectionsArray'] = { type: 'text', id: ele.id };
						ele['sectionsArray'] = { type: 'text', id: ele.id };
						findExistingEngData.push(ele.hasOwnProperty('jsonUpdated'));
						ele.content = [{
							id: ele.id,
							type: 'text',
							isEdit: false,
							lineSpacing: 1,
							content: notesData
						}];
						ele['originalItems'] = JSON.parse(JSON.stringify(ele.content));
						ele['items'] = JSON.parse(JSON.stringify(ele.content));
					} else {
						ele['originalItems'] = [];
						ele['items'] = [];
						ele['originalSectionsArray'] = [];
						ele['sectionsArray'] = [];
					}
				}
        if (this.viewNoteId) {
          if (ele?.engNoteId == this.viewNoteId) {
            ele.isExpand = true;
          }
          if (ele?.notes?.length) {
            ele.notes.forEach(e => {
              if (e.engNoteId == this.viewNoteId) {
                ele.isExpand = true;
                e.isExpand = true;
              }
            });
          }
        }
				parentId.push(ele.engNoteId);
			});
			this.connectedTo = [...parentId, ...childId];
			const autoNoteExists = this.middleNotes.filter(ele => ele.isAutomated).length;
			if (autoNoteExists) {
				this.updateNotesWithLeadSheetValues()
			}
			if (this.trialBalanceData.length > 0) {
				this.updateNotesWithTBValues();  //update the notes data with updated TB values
			}
			setTimeout(() => {
				if (this.tbUpdated || this.lsUpdated) {
					this.saveMiddleNotes(this.middleNotes, "updatedTBValues");
				} else if (localStorage.getItem('addedNotesFromTB') || (findExistingEngData.length && !findExistingEngData.every(value => value))) {
					this.notesFsDataUpdate(null);
				}
			}, 2000);
			this.refreshPreview();
		}, (error) => {
			this.middleNotes = [];
		});
	}

	updateNotesWithTBValues() {
		this.tbUpdated = false;
		this.middleNotes.forEach(note => {
			if (!note.isAutomated) {
				if (note.content && note.content.length) {
					note.content.forEach(section => {
						if (section.type === 'table') {
							const deletedTBRowIds = [];
							section.rows.forEach(row => {
								if (row.trialBalanceId && row.trialBalanceId > 0) {
									const currYearIndex = row.values.findIndex(ele => ele.colId === 'currYear');
									const prevYearIndex = row.values.findIndex(ele => ele.colId === 'priorYear');
									const tbIndex = this.trialBalanceData.findIndex(tb => tb.trialBalanceId === row.trialBalanceId);
									if (tbIndex > -1) {
										if (currYearIndex > -1 && (row.values[currYearIndex].colValue !== this.trialBalanceData[tbIndex].currYearValue)) {
											row.values[currYearIndex].colValue = this.trialBalanceData[tbIndex].currYearValue;
											this.tbUpdated = true;
										}
										if (prevYearIndex > -1 && (row.values[prevYearIndex].colValue !== this.trialBalanceData[tbIndex].prevYearValue)) {
											row.values[prevYearIndex].colValue = this.trialBalanceData[tbIndex].prevYearValue;
											this.tbUpdated = true;
										}
									} else {
										//if TB item got deleted, delete the row
										deletedTBRowIds.push(row.rowId);
										this.tbUpdated = true;
									}
								}
							});
							if (deletedTBRowIds.length > 0) {
								section.rows = section.rows.filter(rw => !deletedTBRowIds.includes(rw.rowId));
							}
						}
					});
				}
				else if (note.notes && note.notes.length) {
					note.notes.forEach(nestedNote => {
						if (nestedNote.content && nestedNote.content.length && !nestedNote.isAutomated) {
							nestedNote.content.forEach(section => {
								if (section.type === 'table') {
									const deletedTBRowIds = [];
									section.rows.forEach(row => {
										if (row.trialBalanceId && row.trialBalanceId > 0) {
											const currYearIndex = row.values.findIndex(ele => ele.colId === 'currYear');
											const prevYearIndex = row.values.findIndex(ele => ele.colId === 'priorYear');
											const tbIndex = this.trialBalanceData.findIndex(tb => tb.trialBalanceId === row.trialBalanceId);
											if (tbIndex > -1) {
												if (currYearIndex > -1 && (row.values[currYearIndex].colValue !== this.trialBalanceData[tbIndex].currYearValue)) {
													row.values[currYearIndex].colValue = this.trialBalanceData[tbIndex].currYearValue;
													this.tbUpdated = true;
												}
												if (prevYearIndex > -1 && (row.values[prevYearIndex].colValue !== this.trialBalanceData[tbIndex].prevYearValue)) {
													row.values[prevYearIndex].colValue = this.trialBalanceData[tbIndex].prevYearValue;
													this.tbUpdated = true;
												}
											} else {
												//if TB item got deleted, delete the row
												deletedTBRowIds.push(row.rowId);
												this.tbUpdated = true;
											}
										}
									});
									if (deletedTBRowIds.length > 0) {
										section.rows = section.rows.filter(rw => !deletedTBRowIds.includes(rw.rowId));
									}
								}
							});
						}
					})
				}
			}
		});
	}

	updateTemplate(data) {
		if (data.notes) {
			this.editorData = data.notes;
		}
		this.isShowEditor = true;
	}
	updateEditorContent(content, data, index, type: "category" | "subCategory") {
		if (type === "subCategory") {
			this.middleNotes[index].notes.forEach(ele => {
				if (data.id == ele.id) {
					this.oldContent = ele.content
					ele.content = content;
				}
			})
		}
		else {
			this.middleNotes[index].content = content;
		}
		this.saveMiddleNotes(this.middleNotes, "update");
	}
	closeEditor(data) {
		this.middleNotes.forEach(ele => {
			if (data.id == ele.id) {
				//ele.content = this.oldContent;
			}
		})
	}

	dropGroup(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.middleNotes, event.previousIndex, event.currentIndex);
		let UpdatedMiddleNotes = this.middleNotes.map((ele, index) => {
			ele.engNoteId = index + 1;
			ele['tempId'] = index + 1;
			let count = 1;
			let count1 = index + 1;
			if (ele.notes) {
				ele.notes.forEach((e, i) => {
					count += 0.1;
					count1 += 0.01;
					if (count <= 2) {
						ele['tempId'] += 0.1;
						e.engNoteId = parseFloat(ele["tempId"]).toFixed(1);
					}
					else if (count > 2) {
						e.engNoteId = parseFloat(count1).toFixed(2);
					}
				})
			}
			delete ele['tempId'];
			return ele;
		})
	}

	drop(event: CdkDragDrop<string[]>, number) {
		if (this.sharedService.isFirmTemplatesNotesEditoropened) {
			this.toaster.error('Please save/cancel changes made to the note before proceeding');
			return;
		}
		// let categoryid = this.middleNotes.map()
		if (event.previousContainer !== event.container) {
			transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
		}
		else {
			if (number == 1) {
				moveItemInArray(this.middleNotes, event.previousIndex, event.currentIndex);
			} else if (number == 2) {
				this.middleNotes.forEach((e, i) => {
					if (e.hasOwnProperty('notes')) {
						moveItemInArray(this.middleNotes[i].notes, event.previousIndex, event.currentIndex);
					}
				});
			}
		}

		let UpdatedMiddleNotes = this.middleNotes.map((ele, index) => {
			ele.engNoteId = index + 1;
			ele['tempId'] = index + 1;
			let count = 1;
			let count1 = index + 1;
			if (ele.notes) {
				ele.notes.forEach(e => {
					count += 0.1;
					count1 += 0.01;
					if (count <= 2) {
						ele['tempId'] += 0.1;
						e.engNoteId = parseFloat(ele["tempId"]).toFixed(1);
						e.sequenceId = +count1.toFixed(2);
						e.sequenceCount = +count.toFixed(1);
					}
					else if (count > 2) {
						e.engNoteId = parseFloat(count1).toFixed(2);
						e.sequenceId = +count1.toFixed(2);
						e.sequenceCount = +count.toFixed(1);
					}
				})
			}
			delete ele['tempId'];
			return ele;
		})
		this.saveMiddleNotes(UpdatedMiddleNotes, "move");
	}


	saveMiddleNotes(allNotes, type?) {
		//delete unwanted properties form Saving Object which we are using for UI only.
		const notesCopy = JSON.parse(JSON.stringify(allNotes));
		if (notesCopy && notesCopy.length) {
			notesCopy.forEach(note => {
				if (!note.notes) {
					delete note.originalItems;
					delete note.items;
					delete note.originalSectionsArray;
					delete note.sectionsArray;
				}

				if (note.notes) {
					note.notes.forEach(subNote => {
						delete subNote.originalItems;
						delete subNote.items;
						delete subNote.originalSectionsArray;
						delete subNote.sectionsArray;
					})
				}
			})
		}
		let jsonString = JSON.stringify(notesCopy);
		var blob = new Blob([jsonString], { type: "text/json;charset=utf-8" });
		let formData: FormData = new FormData();
		let jsonFileName = this.engagementID + "_notes.json";
		const uploadObj = JSON.stringify({
			"module": modules[18],
			"firmId": this.firmUserAcctId,
			"clientId": this.selectedEngagement.clientfirmid,
			"engagementId": this.selectedEngagement.engagementsid,
			"status": 0,
			"folderName": 'notesToFS',
			"appSyncId": this.userLoginId,
			"extension": 'comp'
		})
		formData.append('upload', this.encodingService.enData(uploadObj, "body"));
		formData.append('file', blob, jsonFileName);
		this.updateSpinnerConfig(true);
		this.apiService.saveAndGetFileNamePath(formData).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
			if (response) {
				this.parentCategory = '';
				this.setIsTemplateEdited();
				this.getMiddleNotes(JSON.parse(JSON.stringify(allNotes)));
				if (type === "add") {
					this.toaster.success("Notes added successfully");
				}
				else if (type === "update") {
					this.toaster.success("Notes updated successfully");
				}
				else if (type === "move") {
					this.detectChangeInNotesRelatedToBalancesheet("draganddrop")
					this.detectChangeInNotesRelatedToIncomeStatement("draganddrop")
					this.toaster.success("Notes moved successfully");
				}
				else if (type === "add category") {
					this.toaster.success("Successfully added new category");
				}
				localStorage.setItem("refreshNotes_to_FS", "refresh");
			}
			else {
			}
		})
	}
	refreshPreview() {
		this.updateSpinnerConfig(true);
		this.subscriptions.add(
			this.fsService.fetchFSDocPreview(DocumentPreviewTypes.NOTES).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
				next: res => {
					this.notes$.next(res);
				},
				error: err => {
				}
			})
		);

		// this.sharedService.refreshNotesToFsPreview.next(this.middleNotes);
	}

	// New Notes Data - Start
	fsnotesnaming: string = '';
	parentCategory: any;

	openNotesSection(note) {
		note.isExpand = true;
		this.isAllExpanded();
	}

	closeNotesSection(note) {
		note.isExpand = false;
		this.isAllExpanded();
	}

	setIsTemplateEdited() {
		let isEdited = false;
		this.middleNotes.forEach(val => {
			if (!val.notes) {
				const index = val?.items?.findIndex(itm => itm.isEdit === true);
				if (index > -1) isEdited = true;
			}
			if (val.notes) {
				val.notes.forEach(nt => {
					const index = nt?.items?.findIndex(itm => itm.isEdit === true);
					if (index > -1) isEdited = true;
				});
			}
		});

		if (isEdited) {
			this.sharedService.isFirmTemplatesNotesEditoropened = true;
		} else {
			this.sharedService.isFirmTemplatesNotesEditoropened = false;
		}
	}

	addSection(type: string, lineItem) {
		const id = this.apiService.makeId(4);
		lineItem.sectionsArray.push({ type: type, id: id });
		let content: TextSection | TableSection;
		if (type === 'text') {
			content = {
				id: id,
				type: type,
				isEdit: true,
				lineSpacing: 1,
				content: '',
				jsonUpdated: "release_28"
			}
		} else {
			content = {
				id: id,
				type: type,
				isEdit: true,
				isHeaderHidden: false,
				isHeaderLine: true,
				rows: [],
				columns: [],
				subtotalCount: 0,
				jsonUpdated: "release_28"
			}
		}
		lineItem.items.push(content);
		this.setIsTemplateEdited();
	}

	updateTableData(data: any, index: number, lineItem: any, i: number) {
		const engagementYearEnd = localStorage.getItem("endYear");
		if (lineItem.items.length && lineItem.items.length > 1 && data.isUpdate) {
			lineItem.items.forEach(e => {
				if (!(e.id === data.selectedTable.id)) {
					e?.columns && e.columns.forEach(c => {
						if ((c.colId === 'currYear') || (c.colId === 'priorYear')) {
							const date = this.getFormattedDate(engagementYearEnd, data.selectedTable.columns[0].format, (c.colId === 'currYear'));
							c.format = data.selectedTable.columns[0].format;
							c.formatValue = null;
							c.name = (c.colId === 'currYear' || c.colId === 'priorYear') ? date : c.name;
						}

					});
				}
			});
		}
		if (lineItem?.notes?.length && data.isUpdate) {
			lineItem.notes.forEach(subitems => {
				subitems.items.forEach(e => {
					if (!(e.id === data.selectedTable.id)) {
						e?.columns && e.columns.forEach(c => {
							if ((c.colId === 'currYear') || (c.colId === 'priorYear')) {
								const date = this.getFormattedDate(engagementYearEnd, data.selectedTable.columns[0].format, (c.colId === 'currYear'));
								c.format = data.selectedTable.columns[0].format;
								c.formatValue = null;
								c.name = (c.colId === 'currYear' || c.colId === 'priorYear') ? date : c.name;
							}

						});
					}
				});
			});
		}
		if (Object.keys(data.selectedTable).length !== 0) {
			lineItem.items.splice(index, 1, data.selectedTable);
		}
		if (data.isUpdate || data.isRefresh) {
			const middleNotes = structuredClone(this.middleNotes);
			this.middleNotes = [];
			this.middleNotes = middleNotes;
		}
		// this.isFsTableNoteSave && this.saveNotes(lineItem);
		// if (this.saveEvent.getValue() === 'saveClicked') {
		// 	this.saveEvent.next(null);
		// 	this.saveNotes(lineItem);
		// }
		this.setIsTemplateEdited();
	}


	updateEditProperty(isEdit: boolean, note, itemIndex, noteIndex) {
		if (this.previousEditNote !== -1 && this.previousEditNote !== noteIndex && this.middleNotes[this.previousEditNote]?.originalItems && this.middleNotes[this.previousEditNote]?.originalSectionsArray) {
			this.middleNotes[this.previousEditNote].items = JSON.parse(JSON.stringify(this.middleNotes[this.previousEditNote].originalItems));
			this.middleNotes[this.previousEditNote].sectionsArray = JSON.parse(JSON.stringify(this.middleNotes[this.previousEditNote].originalSectionsArray));
		}
		this.middleNotes.forEach(element => {
			if (element?.notes && element.notes.length) {
				element.notes.forEach(note => {
					note?.items.forEach(c => {
						c.isEdit = false;
					});
					note?.originalItems.forEach(c => {
						c.isEdit = false;
					});
				});
			}
		});
		note.items[itemIndex].isEdit = isEdit;
		this.previousEditNote = noteIndex;
		this.setIsTemplateEdited();
	}

	deleteSection(lineItem, index: number) {
		lineItem.items.splice(index, 1);
		lineItem.sectionsArray.splice(index, 1);
		this.setIsTemplateEdited();
	}

	updateTextEditorData(data: TextSection, index: number, lineItem) {
		lineItem.items[index]['content'] = data.content;
		lineItem.items[index]['lineSpacing'] = data.lineSpacing;
		this.setIsTemplateEdited();
	}

	moveDown(lineItem, index: number) {
		moveItemInArray(lineItem.sectionsArray, index, index + 1);
		moveItemInArray(lineItem.items, index, index + 1);
		this.setIsTemplateEdited();
	}

	moveUp(lineItem, index: number) {
		moveItemInArray(lineItem.sectionsArray, index, index - 1);
		moveItemInArray(lineItem.items, index, index - 1);
		this.setIsTemplateEdited();
	}

	cancelSaveNotes(lineItem) {
		lineItem.items = JSON.parse(JSON.stringify(lineItem.originalItems));
		lineItem.sectionsArray = JSON.parse(JSON.stringify(lineItem.originalSectionsArray));
		lineItem.items.forEach(val => val.isEdit = false);
		this.setIsTemplateEdited();
		this.isFsTableNoteSave = false;
	}

	saveLatestDataFromFsTable(type: string) {
		this.isFsTableNoteError = false;
		this.isFsTableNoteSave = true;
		this.fsTableComponent.map(fstable => {
			fstable.emitTableSectiondata();
		});
		this.customEditorComponent.map(custEditor => {
			custEditor.emitTextSectionData();
		});
		if (!this.isFsTableNoteError) {
			this.isFsTableNoteSave = false;
			this.middleNotes.forEach(lineItem => {
				if (lineItem?.items?.length && lineItem.items.some(item => (item.type === 'table' && item.hasOwnProperty('columns') && item['columns'].length === 0))) {
					this.toaster.error('Add column to enable action');
					this.isFsTableNoteError = true;
				} else if (lineItem?.notes?.length) {
					lineItem.notes.forEach(subitem => {
						if (subitem?.items?.length && subitem.items.some(item => (item.type === 'table' && item.hasOwnProperty('columns') && item['columns'].length === 0))) {
							this.toaster.error('Add column to enable action');
							this.isFsTableNoteError = true;
						}
					});
				}
			});

			if (!this.isFsTableNoteError) {
				this.middleNotes.forEach(lineItem => {
					if (lineItem?.items) {
						lineItem.items.forEach(val => val.isEdit = false);
						lineItem.originalItems = JSON.parse(JSON.stringify(lineItem.items));
						lineItem.originalSectionsArray = JSON.parse(JSON.stringify(lineItem.sectionsArray));
						lineItem.content = JSON.parse(JSON.stringify(lineItem.items));
					}
					if (lineItem?.notes?.length) {
						lineItem.notes.forEach(subitem => {
							subitem.items.forEach(val => val.isEdit = false);
							subitem.originalItems = JSON.parse(JSON.stringify(subitem.items));
							subitem.originalSectionsArray = JSON.parse(JSON.stringify(subitem.sectionsArray));
							subitem.content = JSON.parse(JSON.stringify(subitem.items));
						});
					}

				});
				console.log(this.middleNotes)
				this.saveMiddleNotes(this.middleNotes, type);
			}

		}
	}

	saveNotes(lineItem) {
		if (lineItem.items.some(item => item.type === 'table' && item.hasOwnProperty('columns') && item['columns'].length === 0)) {
			this.toaster.error('Add column to enable action');
			this.isFsTableNoteError = true;
		} else {
			if (!this.saveEnabled(lineItem?.items, lineItem?.originalItems) && this.justEditChanged(lineItem?.items, lineItem?.originalItems)) {
				lineItem.items.forEach(val => val.isEdit = false);
				this.setIsTemplateEdited();
				return;
			} else {
				lineItem.items.forEach(val => val.isEdit = false);
				lineItem.originalItems = JSON.parse(JSON.stringify(lineItem.items));
				lineItem.originalSectionsArray = JSON.parse(JSON.stringify(lineItem.sectionsArray));
				lineItem.content = JSON.parse(JSON.stringify(lineItem.items));
				// this.saveMiddleNotes(this.middleNotes, "update");
			}
		}
	}

	justEditChanged(items, originalItems): boolean {
		if (items?.length || originalItems?.length) {
			const isEdits1 = items.map(sec => sec.isEdit);
			const isEdits2 = originalItems.map(sec => sec.isEdit);
			if (isEdits1.join('') !== isEdits2.join('')) {
				this.notesEditted = true;
				return true;
			}
			this.notesEditted = false;
			return false;
		}
		this.notesEditted = false;
		return false;
	}

	saveEnabled(items, originalItems): boolean {
		if (items?.length || originalItems?.length) {
			if (items.length !== originalItems.length) {
				this.notesEditted = true;
				return true;
			} else {

				//Check ids first, if sequence is same or not
				const ids1 = items.map(sec => sec.id);
				const ids2 = originalItems.map(sec => sec.id);
				if (ids1.join('') !== ids2.join('')) {
					this.notesEditted = true;
					return true;
				} else {
					for (let i = 0; i < originalItems.length; i++) {
						if (originalItems[i].id === items[i].id && items[i].type === 'text') {
							if ((originalItems[i]['content'] !== items[i]['content']) || (originalItems[i]['lineSpacing'] !== items[i]['lineSpacing'])) {
								this.notesEditted = true;
								return true;
							}

						} else if (originalItems[i].id === items[i].id && items[i].type === 'table') {
							//check isHeaderHidden - 1
							if ((originalItems[i]['isHeaderHidden'] !== items[i]['isHeaderHidden']) || (originalItems[i]['isHeaderLine'] !== items[i]['isHeaderLine']) ||
								(this.compareColumns(originalItems[i]['columns'], items[i]['columns'])) || (this.compareRows(originalItems[i]['rows'], items[i]['rows']))) {
								this.notesEditted = true;
								return true;
							}
						}
					}
				}
			}
			this.notesEditted = false;
			return false;
		}
		this.notesEditted = false;
		return false;
	}

	compareColumns(oldCols: Column[], newCols: Column[]): boolean {
		if (oldCols.length !== newCols.length) {
			return true;
		} else {
			for (let i = 0; i < newCols.length; i++) {
				if (!objectsEqual(newCols[i], oldCols[i])) {
					return true;
				}
			}
		}
		return false;
	}

	compareRows(oldRows: Row[], newRows: Row[]): boolean {
		if (!(oldRows.length === newRows.length) || !(newRows.map(row => row.rowId).join('') === oldRows.map(row => row.rowId).join('')) || !(newRows.map(row => row.name).join('') === oldRows.map(row => row.name).join('')) || !(newRows.map(row => row.isDeleted).join('') === oldRows.map(row => row.isDeleted).join('')) ||
			!(newRows.map(row => row.isHide).join('') === oldRows.map(row => row.isHide).join('')) || !(newRows.map(row => row.isDescHide).join('') === oldRows.map(row => row.isDescHide).join('')) || !(newRows.map(row => row.isLineHide).join('') === oldRows.map(row => row.isLineHide).join(''))) {
			return true;
		}

		for (let j = 0; j < newRows.length; j++) {
			for (let i = 0; i < newRows[j].values.length; i++) {
				if (!objectsEqual(newRows[j].values[i], oldRows[j].values[i])) {
					return true;
				}
			}
		}

		return false;
	}


	async getNotesTrialBalanceData() {
		this.autoLeadSheetData = [];
		await this.getNotesLeadSheetData().then(response => {
			this.autoLeadSheetData = JSON.parse(JSON.stringify(response));
		});
		this.sharedService.notesLeadSheetData$.next(this.autoLeadSheetData);
		const data = {
			"engagementsId": this.engagementData.engagementsid.toString(),
			"acctYear": this.datePipe.transform(this.engagementData.yearEnd, 'y')
		}
		this.updateSpinnerConfig(true);
		this.apiService.getNotesTableTrialBalance(data).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
			if (response) {
				const tbResponse = !response ? { row: [] } : JSON.parse(response);
				this.trialBalanceData = tbResponse.row;
				this.getMiddleNotes();
				this.sharedService.notesTrialBalanceData$.next(this.trialBalanceData);
			} else {
			}
		}, (error) => {
			this.toaster.error(error.error);
			this.getMiddleNotes();
			this.sharedService.notesTrialBalanceData$.next([]);
		});
	}

	openCreateNotesToFsDialog(category: any) {
		this.parentCategory = JSON.parse(JSON.stringify(category));
		this.dialog.open(this.CreateNotesToFsDialog, {});
	}

	avoidUnderscore(event) {
		var k = event ? event.which : event.keyCode;
		if (k == 95) return false;
	}

	// creating fsnotesnaming
	createfirmtemplatesfsnotes() {
		if (!this.fsnotesnaming || !this.fsnotesnaming.trim()) {
			this.toaster.error("Missing note name.");
			return
		}
		var noteObj = { 'id': this.apiService.makeId(4), 'name': this.fsnotesnaming, 'content': [], 'originalItems': [], 'items': [], 'originalSectionsArray': [], 'sectionsArray': [] };
		const index = this.middleNotes.findIndex(x => x.categoryId === this.parentCategory.categoryId);
		if (index > -1) {
			noteObj['engNoteId'] = this.middleNotes[index].engNoteId + '.' + (this.middleNotes[index].notes.length ? parseInt(this.middleNotes[index].notes[this.middleNotes[index].notes.length - 1].engNoteId.split('.')[1]) + parseInt('1') : 1);
			this.middleNotes[index].notes.push(noteObj);
			this.fsnotesnaming = '';
			this.saveMiddleNotes(this.middleNotes, "add");
		}
	}

	//New Notes Data - End

	isPreviewPanelExpanded: any;
	index: any;



	ngOnDestroy() {
		clearTimeout(this.userActivity);
	}

	// get submodules
	getwbleftside() {
    this.wbService.getWbLeftSide(this.engagementData.engagementsid).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          JSON.parse(res?.data).forEach(e => {
            if (e.uirouting === 'cashflow') {
              this.cashFlowSubModuleId = e.submoduleid;
            }
            if (e.uirouting === 'stockholdersequity') {
              this.stockHolderSubmoduleId = e.submoduleid;
            }
            if (e.uirouting === 'notestofs') {
              this.workBookSubModuleId = e.submoduleid;
            }

          });
          this.getTBLSHeaderNotes();
        } else {
          this.getTBLSHeaderNotes();
        }
      }, error: e => {
        this.getTBLSHeaderNotes();
        this.toaster.error(e.error);
      }
    })
	}

	expandCollapseNotes(isFSNotesExpanded) {
		this.isFSNotesExpanded = !isFSNotesExpanded;
		this.middleNotes.forEach(val => {
			val['isExpand'] = this.isFSNotesExpanded;
			val.isEditorOpen = this.isFSNotesExpanded;
			if (val.notes && val.notes.length) {
				val.notes.forEach(nt => {
					nt['isExpand'] = this.isFSNotesExpanded;
					nt.isEditorOpen = this.isFSNotesExpanded;
				});
			}
		});
	}

	isAllExpanded() {
		const val = this.middleNotes.every(val => val.isExpand === true);
		this.isFSNotesExpanded = (val) ? true : false;
	}

	getPPENoteData(): Promise<any[]> {
		const acctYear = this.datePipe.transform(this.engagementData.yearEnd, 'y');
		this.updateSpinnerConfig(true);
		return new Promise((resolve, reject) => {
			this.apiService.getAutoNotesData(this.engagementData.engagementsid, acctYear).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
				var autoNoteData = [];
				if (response && response.data && response.data.length) {
					autoNoteData = [...response.data];
				}
				resolve(autoNoteData);
			}, (error) => {
				reject([]);
			});
		});
	}

	getNotesLeadSheetData(): Promise<any[]> {
		const acctYear = this.datePipe.transform(this.engagementData.yearEnd, 'y');
		this.updateSpinnerConfig(true);
		return new Promise((resolve, reject) => {
			this.apiService.getLeadSheetData(this.engagementData.engagementsid, acctYear).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe((response: any) => {
				var leadSheetData = [];
				if (response && response.data && response.data.length) {
					leadSheetData = [...response.data];
				}
				resolve(leadSheetData);
			}, (error) => {
				reject([]);
			});
		});
	}

	updateNotesWithLeadSheetValues() {
		this.lsUpdated = false;
		this.middleNotes.forEach(note => {
			if (note.isAutomated) {
				if (note.content && note.content.length) {
					note.content.forEach(section => {
						if (section.type === 'table') {
							const deletedLSRowIds = [];
							const existingTrialBalCodes = [];
							section.rows.forEach(row => {
								if (row.trialBalanceId) {
									const costIndex = row.values.findIndex(ele => ele.colId === 'cost');
									const amortizationIndex = row.values.findIndex(ele => ele.colId === 'amortization');
									const currYearIndex = row.values.findIndex(ele => ele.colId === 'currYear');
									const priorYearIndex = row.values.findIndex(ele => ele.colId === 'priorYear');
									const lsIndex = this.autoLeadSheetData.findIndex(tb => tb.trialBalanceId === row.trialBalanceId);
									if (lsIndex > -1) {
										existingTrialBalCodes.push(row.trialBalanceId);
										if (row.name !== this.autoLeadSheetData[lsIndex].accountName && !row.isDescManuallyChanged) {
											row.name = this.autoLeadSheetData[lsIndex].accountName;
											this.lsUpdated = true;
										}
										if (costIndex > -1 && (row.values[costIndex].tbValue !== this.autoLeadSheetData[lsIndex].cost)) {
											row.values[costIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].cost);
											row.values[costIndex].tbValue = this.autoLeadSheetData[lsIndex].cost;
											this.lsUpdated = true;
										}
										if (amortizationIndex > -1 && (row.values[amortizationIndex].tbValue !== this.autoLeadSheetData[lsIndex].amortizationFinalAmount)) {
											row.values[amortizationIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].amortizationFinalAmount || 0);
											row.values[amortizationIndex].tbValue = this.autoLeadSheetData[lsIndex].amortizationFinalAmount;
											this.lsUpdated = true;
										}
										if (currYearIndex > -1 && (row.values[currYearIndex].tbValue !== this.autoLeadSheetData[lsIndex].netBookValue)) {
											row.values[currYearIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].netBookValue);
											row.values[currYearIndex].tbValue = this.autoLeadSheetData[lsIndex].netBookValue;
											this.lsUpdated = true;
										}
										if (priorYearIndex > -1 && (row.values[priorYearIndex].tbValue !== this.autoLeadSheetData[lsIndex].py1NetBookValue)) {
											row.values[priorYearIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].py1NetBookValue);
											row.values[priorYearIndex].tbValue = this.autoLeadSheetData[lsIndex].py1NetBookValue;
											this.lsUpdated = true;
										}
									} else {
										//if LS item got deleted, delete the row
										deletedLSRowIds.push(row.rowId);
										this.lsUpdated = true;
									}
								}
							});
							if (this.autoLeadSheetData.length > existingTrialBalCodes.length) {
								this.lsUpdated = true;
								const filteredRows = this.autoLeadSheetData.filter(rw => !existingTrialBalCodes.includes(rw.trialBalanceId));
								filteredRows.forEach((val, index) => {
									let valuesObj = [
										{ colId: "cost", colValue: ((val.cost || 0) < 0) ? this.roundUpNegativeValue((val.cost || 0)) : Math.round((val.cost || 0)) },
										{ colId: "amortization", colValue: ((val.amortizationFinalAmount || 0) < 0) ? this.roundUpNegativeValue(val.amortizationFinalAmount || 0) : Math.round(val.amortizationFinalAmount || 0) },
										{ colId: "currYear", colValue: ((val.netBookValue || 0) < 0) ? this.roundUpNegativeValue((val.netBookValue || 0)) : Math.round((val.netBookValue || 0)) },
										{ colId: "priorYear", colValue: ((val.py1NetBookValue || 0) < 0) ? this.roundUpNegativeValue((val.py1NetBookValue || 0)) : Math.round((val.py1NetBookValue || 0)) },
									];
									let row = {
										isHide: false,
										name: val.accountName,
										trialBalanceId: val.trialBalanceId,
										rowId: (section.rows.length + 1).toString(),
										values: valuesObj
									}
									section.rows.push(row);
								})
							}
							if (deletedLSRowIds.length > 0) {
								section.rows = section.rows.filter(rw => !deletedLSRowIds.includes(rw.rowId));
							}
							// const totaRowIndex = section.rows.findIndex(val => val.rowId === 'totalrow');
							// if (totaRowIndex > -1) {
							// 	section.rows.splice(totaRowIndex, 1);
							// }
							const crossCheckIndex = section.rows.findIndex(val => val.rowId === 'crossCheck');
							if (crossCheckIndex > -1) {
								section.rows.splice(crossCheckIndex, 1);
							}
						}
					});
				}
				else if (note.notes && note.notes.length) {
					note.notes.forEach(nestedNote => {
						if (nestedNote.content && nestedNote.content.length && nestedNote.isAutomated) {
							nestedNote.content.forEach(section => {
								if (section.type === 'table') {
									const deletedLSRowIds = [];
									const existingTrialBalCodes = [];
									section.rows.forEach(row => {
										if (row.trialBalanceId) {
											const costIndex = row.values.findIndex(ele => ele.colId === 'cost');
											const amortizationIndex = row.values.findIndex(ele => ele.colId === 'amortization');
											const currYearIndex = row.values.findIndex(ele => ele.colId === 'currYear');
											const priorYearIndex = row.values.findIndex(ele => ele.colId === 'priorYear');
											const lsIndex = this.autoLeadSheetData.findIndex(tb => tb.trialBalanceId === row.trialBalanceId);
											if (lsIndex > -1) {
												existingTrialBalCodes.push(row.trialBalanceId);
												if (row.name !== this.autoLeadSheetData[lsIndex].accountName && !row.isDescManuallyChanged) {
													row.name = this.autoLeadSheetData[lsIndex].accountName;
													this.lsUpdated = true;
												}
												if (costIndex > -1 && (row.values[costIndex].tbValue !== this.autoLeadSheetData[lsIndex].cost)) {
													row.values[costIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].cost);
													row.values[costIndex].tbValue = this.autoLeadSheetData[lsIndex].cost;
													this.lsUpdated = true;
												}
												if (amortizationIndex > -1 && (row.values[amortizationIndex].tbValue !== this.autoLeadSheetData[lsIndex].amortizationFinalAmount)) {
													row.values[amortizationIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].amortizationFinalAmount || 0);
													row.values[amortizationIndex].tbValue = this.autoLeadSheetData[lsIndex].amortizationFinalAmount;
													this.lsUpdated = true;
												}
												if (currYearIndex > -1 && (row.values[currYearIndex].tbValue !== this.autoLeadSheetData[lsIndex].netBookValue)) {
													row.values[currYearIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].netBookValue);
													row.values[currYearIndex].tbValue = this.autoLeadSheetData[lsIndex].netBookValue;
													this.lsUpdated = true;
												}
												if (priorYearIndex > -1 && (row.values[priorYearIndex].tbValue !== this.autoLeadSheetData[lsIndex].py1NetBookValue)) {
													row.values[priorYearIndex].colValue = this.getFormattedValue(this.autoLeadSheetData[lsIndex].py1NetBookValue);
													row.values[priorYearIndex].tbValue = this.autoLeadSheetData[lsIndex].py1NetBookValue;
													this.lsUpdated = true;
												}
											} else {
												//if LS item got deleted, delete the row
												deletedLSRowIds.push(row.rowId);
												this.lsUpdated = true;
											}
										}
									});
									if (this.autoLeadSheetData.length > existingTrialBalCodes.length) {
										this.lsUpdated = true;
										const filteredRows = this.autoLeadSheetData.filter(rw => !existingTrialBalCodes.includes(rw.trialBalanceId));
										filteredRows.forEach((val, index) => {
											let valuesObj = [
												{ colId: "cost", colValue: ((val.cost || 0) < 0) ? this.roundUpNegativeValue((val.cost || 0)) : Math.round((val.cost || 0)) },
												{ colId: "amortization", colValue: ((val.amortizationFinalAmount || 0) < 0) ? this.roundUpNegativeValue(val.amortizationFinalAmount || 0) : Math.round(val.amortizationFinalAmount || 0) },
												{ colId: "currYear", colValue: ((val.netBookValue || 0) < 0) ? this.roundUpNegativeValue((val.netBookValue || 0)) : Math.round((val.netBookValue || 0)) },
												{ colId: "priorYear", colValue: ((val.py1NetBookValue || 0) < 0) ? this.roundUpNegativeValue((val.py1NetBookValue || 0)) : Math.round((val.py1NetBookValue || 0)) },
											];
											let row = {
												isHide: false,
												name: val.accountName,
												trialBalanceId: val.trialBalanceId,
												rowId: (section.rows.length + 1).toString(),
												values: valuesObj
											}
											section.rows.push(row);
										})
									}
									if (deletedLSRowIds.length > 0) {
										section.rows = section.rows.filter(rw => !deletedLSRowIds.includes(rw.rowId));
									}
									// const totaRowIndex = section.rows.findIndex(val => val.rowId === 'totalrow');
									// if (totaRowIndex > -1) {
									// 	section.rows.splice(totaRowIndex, 1);
									// }
									const crossCheckIndex = section.rows.findIndex(val => val.rowId === 'crossCheck');
									if (crossCheckIndex > -1) {
										section.rows.splice(crossCheckIndex, 1);
									}
								}
							});
						}
					})
				}
			}
		});
	}

	getFormattedValue(val) {
		return ((val || 0) < 0) ? this.roundUpNegativeValue((val || 0)) : Math.round((val || 0));
	}

	roundUpNegativeValue(val: number): number {
		val = val * -1;
		val = Math.round(val);
		val = val * -1;
		return val;
	}

	getFormattedDate(date: string, format: string, isCurrentYear?: boolean) {
		let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		if (format === 'short') {
			months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		}
		const dateObj = new Date(date);
		if (isCurrentYear) {
			return format === 'year' ? `${dateObj.getFullYear()}` : `${months[dateObj.getMonth()]} ${dateObj.getDate().toString().padStart(2, "0")}, ${dateObj.getFullYear()}`;
		} else {
			return format === 'year' ? `${dateObj.getFullYear() - 1}` : `${months[dateObj.getMonth()]} ${dateObj.getDate().toString().padStart(2, "0")}, ${dateObj.getFullYear() - 1}`;
		}
	}

	notesFsDataUpdate(type: string) {
		this.middleNotes.forEach((ele, j) => {
			if (!ele.notes) {
				if (ele.content && ele.content.length) {
					ele?.content.forEach(c => {
						if (!c.hasOwnProperty('jsonUpdated') || type === 'add' || localStorage.getItem('addedNotesFromTB')) {
							c.jsonUpdated = c.hasOwnProperty('jsonUpdated') ? c.jsonUpdated : 'release_28';
							if (c.type === 'table') {
								c?.columns && c.columns.forEach(e => {
									e.format = !e.hasOwnProperty('format') ? 'long' : (e.format ? e.format : 'long');
									e.styles = !e.hasOwnProperty('styles') ? (e.colId === 'currYear' ? ['bold'] : []) : (e.styles?.length ? e.styles : (e.colId === 'currYear' ? ['bold'] : []));
									e.formatValue = null;
									e.name = (e.colId === 'currYear' || e.colId === 'priorYear') ? this.getFormattedDate(this.engagementYearEnd, e.format, (e.colId === 'currYear')) : e.name;
								});
								c.isHeaderLine = !c.hasOwnProperty('isHeaderLine') ? true : c.isHeaderLine;
								c?.rows && c.rows.forEach(row => {
									row.isLineHide = !row.hasOwnProperty('isLineHide') ? false : row.isLineHide;
									row.isDescHide = !row.hasOwnProperty('isDescHide') ? false : row.isDescHide;
									row.styles = !row.hasOwnProperty('styles') ? ((row.rowId === 'subtotal' || row.rowId === 'totalrow') ? ['bold'] : []) : row.styles;
									row.isChecked = false;
								});
							} else if (c.type === 'text') {
								const div = document.createElement('p');
								div.innerHTML = c.content;
								div.style.lineHeight = c?.lineSpacing ? c.lineSpacing + '' : '1';
								const elements = div.querySelectorAll('p,div,span.h1,h2,h3,h4,h5,h6');
								elements.forEach((tag: any) => {
									tag.style.lineHeight = c?.lineSpacing ? c.lineSpacing + '' : '1';
								});
								c.content = div.innerHTML;
							}
						}
					});
				}
			}
			if (ele.notes) {
				ele.notes.forEach(element => {
					if (element.content && element.content.length) {
						element?.content.forEach(c => {
							if (!c.hasOwnProperty('jsonUpdated') || type === 'add' || localStorage.getItem('addedNotesFromTB')) {
								c.jsonUpdated = c.hasOwnProperty('jsonUpdated') ? c.jsonUpdated : 'release_28';
								if (c.type === 'table') {
									c?.columns && c.columns.forEach(e => {
										e.format = !e.hasOwnProperty('format') ? 'long' : (e.format ? e.format : 'long');
										e.styles = !e.hasOwnProperty('styles') ? (e.colId === 'currYear' ? ['bold'] : []) : (e.styles?.length ? e.styles : (e.colId === 'currYear' ? ['bold'] : []));
										e.formatValue = null;
										e.name = (e.colId === 'currYear' || e.colId === 'priorYear') ? this.getFormattedDate(this.engagementYearEnd, e.format, (e.colId === 'currYear')) : e.name;
									});
									c.isHeaderLine = !c.hasOwnProperty('isHeaderLine') ? true : c.isHeaderLine;
									c?.rows && c.rows.forEach(row => {
										row.isLineHide = !row.hasOwnProperty('isLineHide') ? false : row.isLineHide;
										row.isDescHide = !row.hasOwnProperty('isDescHide') ? false : row.isDescHide;
										row.styles = !row.hasOwnProperty('styles') ? ((row.rowId === 'subtotal' || row.rowId === 'totalrow') ? ['bold'] : []) : row.styles;
										row.isChecked = false;
									});
								} else if (c.type === 'text') {
									const div = document.createElement('p');
									div.innerHTML = c.content;
									div.style.lineHeight = c?.lineSpacing ? c.lineSpacing + '' : '1';
									const elements = div.querySelectorAll('p,div,span.h1,h2,h3,h4,h5,h6');
									elements.forEach((tag: any) => {
										tag.style.lineHeight = c?.lineSpacing ? c.lineSpacing + '' : '1';
									});
									c.content = div.innerHTML;
								}
							}
						});
					}
				});
			}
		});
		localStorage.removeItem('addedNotesFromTB');
		setTimeout(() => {
			this.saveMiddleNotes(this.middleNotes, type);
		}, 1000);
	}

  public onResizePanelEnd(resizeData: ResizeModel) {
    resizeData.width < resizeData.minWidth ? this.drawer.close() : '';
  }


  private updateSpinnerConfig(value: boolean) {
    value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
    this.spinnerConfig.update((config) => ({...config, isSpinShown: this.spinCount > 0}));
	 }
}
